import React, { Component } from 'react';
import L from 'leaflet';
// import {Map, Marker } from 'react-leaflet';
// postCSS import of Leaflet's CSS
import 'leaflet/dist/leaflet.css';
import EasyButton from 'leaflet-easybutton';
import 'leaflet-easybutton/src/easy-button.css';
// using webpack json loader we can import our geojson file like this
// import geojson from 'json!./bk_subway_entrances.geojson';
// import local components Filter and ForkMe
// import Filter from './Filter';
// import ForkMe from './ForkMe';
// import MarkerClusterGroup from 'react-leaflet-markercluster';
import MarkerClusterGroup from 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import { Icon } from 'react-fa';
import ReactTimeout from 'react-timeout';
import { Modal, Spin, Icon as AntdIcon } from 'antd';
import openSocket from 'socket.io-client';
// import MaterialInitials from 'react-native-material-initials/native';
// store the map configuration properties in an object,
// we could also move this to a separate file & import it if desired.
const colSep = String.fromCharCode(14);
const cnfmModal = Modal.confirm;
const { FaIcon, FaStack } = require('react-fa-icon');
const enablePolyline = false;
let config = {};
config.params = {
  center: [42.630029, -71.353681],
  zoomControl: false,
  zoom: 13,
  maxZoom: 25,
  minZoom: 2,
  scrollwheel: false,
  legends: true,
  infoControl: false,
  attributionControl: true
};
config.tileLayer = {
  uri: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  params: {
    minZoom: 2,
    // attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="">QRyde</a>',
    attribution: 'Maps © <a href=\"www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors | QRyde GSE',
    id: '',
    accessToken: ''
  }
};
let configSatellite = {};
configSatellite.params = {
  center: [42.630029, -71.353681],
  zoomControl: false,
  zoom: 13,
  maxZoom: 25,
  minZoom: 2,
  scrollwheel: false,
  legends: true,
  infoControl: false,
  attributionControl: true
};
configSatellite.tileLayer = {
  uri: 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
  params: {
    minZoom: 2,
    attribution: 'Maps © <a href="http://www.esri.com/">Esri</a> contributors | QRyde GSE',
  }
};
const tileLayer = L.tileLayer(config.tileLayer.uri, config.tileLayer.params);
const tileSatelliteLayer = L.tileLayer(configSatellite.tileLayer.uri, configSatellite.tileLayer.params);
let marker = {};
marker.red = L.icon({
  iconUrl: require('../img/busStop0.png'),
  iconSize: [24, 32],
  iconAnchor: [12, 32],
  popAnchor: [12, 3]
});
marker.black = L.icon({
  iconUrl: require('../img/busStop1.png'),
  iconSize: [24, 32],
  iconAnchor: [12, 32],
  popAnchor: [12, 3]
});
marker.pu = L.divIcon({
  className: 'my-div-icon',
  html: "<div style=\"border-radius: 50%; behavior: url(PIE.htc); width: 26px; height: 26px; background: RoyalBlue; border: 2px solid #666; color: white; text-align: center; font: 20px Arial, sans-serif; \">P</div>"
});
marker.do = L.divIcon({
  className: 'my-div-icon',
  html: "<div style=\"border-radius: 50%; behavior: url(PIE.htc); width: 26px; height: 26px; background: Crimson; border: 2px solid #666; color: white; text-align: center; font: 20px Arial, sans-serif; \">D</div>"
});
marker.pu_hollow = L.divIcon({
  className: 'my-div-icon',
  html: "<div style=\"border-radius: 50%; behavior: url(PIE.htc); width: 30px; height: 30px; background: RoyalBlue; border: 5px solid #ff8000; color: white; text-align: center; font: 20px Arial, sans-serif; \">P</div>"
});
marker.do_hollow = L.divIcon({
  className: 'my-div-icon',
  html: "<div style=\"border-radius: 50%; behavior: url(PIE.htc); width: 30px; height: 30px; background: Crimson; border: 5px solid #ff8000; color: white; text-align: center; font: 20px Arial, sans-serif; \">D</div>"
});
marker.vehicle = L.divIcon({
  className: 'my-div-icon',
  html: "<div style=\"border-radius: 50%; behavior: url(PIE.htc); width: 16px; height: 16px; background: Lime; border: 2px solid #666; color: white; text-align: center; font: 20px Arial, sans-serif; \"></div>"
});
marker.current_location = L.divIcon({
  className: 'my-div-icon',
  html: "<div style=\"border-radius: 50%; behavior: url(PIE.htc); width: 20px; height: 20px; background: red; border: 3px solid #ff8000; color: white; text-align: center; font: 20px Arial, sans-serif; \"></div>"
});
// let test_marker = window.L.Marker.movingMarker([[48.8567, 2.3508],[50.45, 30.523333]], [20000]);

class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      map: null,
      easyBar: null,
      trips: [],
      tileLayer: null,
      geojsonLayer: null,
      geojson: null,
      subwayLinesFilter: '*',
      numEntrances: null,
      clusters: {},
      selectedSegment: [],
      selectedSegmentPolyline: {},
      selectedSegmentPlayPolylines: [],
      selectedTripsClustersRb: "trips",
      selectedPuDoRb: "pudo",
      selectedTimeSlots: { 0: true, 1: true, 2: true, 3: true, 4: true, 5: true, 6: true, 7: true, 8: true, 9: true, 10: true, 11: true, 12: true, 13: true, 14: true, 15: true, 16: true, 17: true, 18: true, 19: true, 20: true, 21: true, 22: true, 23: true, 24: true, 25: true, 26: true, 27: true, 28: true, 29: true, 30: true, 31: true, 32: true, 33: true, 34: true, 35: true, 36: true, 37: true, 38: true, 39: true, 40: true, 41: true, 42: true, 43: true, 44: true, 45: true, 46: true, 47: true, 48: true, 49: true, 50: true, 51: true, 52: true, 53: true, 54: true, 55: true, 56: true, 57: true, 58: true, 59: true, 60: true, 61: true, 62: true, 63: true, 64: true, 65: true, 66: true, 67: true, 68: true, 69: true, 70: true, 71: true, 72: true, 73: true, 74: true, 75: true, 76: true, 77: true, 78: true, 79: true, 80: true, 81: true, 82: true, 83: true, 84: true, 85: true, 86: true, 87: true, 88: true, 89: true, 90: true, 91: true, 92: true, 93: true, 94: true, 95: true },
      selectAllTimeSlots: 1,
      timeSlotMin: 0,
      timeSlotMax: 95,
      playSegmentTimeOut: null,
      playSegmentInterval: 88.66,
      playSegmentPoints: 6,
      playSegmentVehicleMarker: null,
      playSegmentStatus: "stop"
    };
    // this.deepEqual = require('deep-equal');
    this._mapNode = null;
    // this.isFindBestMode = false;
    this.findBestTripIdx = -1;
    this.findBestData = [];
    this.findBestPuMarker = null;
    this.findBestDoMarker = null;
    this.findBestPuPopup = null;
    this.findBestDoPopup = null;
    this.selectedSegmentCurrentLocation = {};
    this.selectedSegmentCurrentLocationMarker = {};
    this.trackSelectedSegmentInterval = 17;
    this.trackSelectedSegmentTimeout = null;
    this.plotSelectedSegmentCurrentLocationInterval = 1;
    this.plotSelectedSegmentCurrentLocationTimeout = null;
    this.segmentsForSelectedTrips = [];
    this.previousZoom = { centerLat: 0, centerLng: 0 };
    this.handleAcceptFindBestFinish = this.handleAcceptFindBestFinish.bind(this);
    this.tempShowAllSegmentsCulster = {};
  }

  componentDidMount() {
    // code to run just after the component "mounts" / DOM elements are created
    // we could make an AJAX request for the GeoJSON data here if it wasn't stored locally
    // create the Leaflet map object
    if (!this.state.map) this.init(this._mapNode);
    if (this.props.trips != null && this.props.trips.length != 0) {
      this.setState({ trips: this.props.trips });
      if (this.state.trips === null || this.state.trips.length === 0) {
        this.state.trips = this.props.trips;
      }
    }
    if (this.state.trips != null && this.state.trips.length != 0) {
      this.addClustersAndPreparePolylines();
    }
  }

  resetMap() {
    if (this.state.playSegmentStatus === "play" || this.state.playSegmentStatus === "pause") {
      this.stopSegment();
    }
    this.clearSelectedSetmentFromMap();
    this.clearTripsFromMap();
    this.setState({
      trips: [],
      clusters: {},
      selectedSegment: [],
      selectedSegmentPolyline: {},
      selectedSegmentPlayPolylines: [],
      playSegmentTimeOut: null,
      playSegmentVehicleMarker: null,
      playSegmentStatus: "stop"
    });
    this.state.trips = [];
    this.state.clusters = {};
    this.state.selectedSegment = [];
    this.state.selectedSegmentPolyline = {};
    this.state.selectedSegmentPlayPolylines = [];
    this.state.playSegmentTimeOut = null;
    this.state.playSegmentVehicleMarker = null;
    this.state.playSegmentStatus = "stop";

    // if (this.isFindBestMode) {
    if (this.findBestTripIdx >= 0) {
      if (this.findBestPuMarker != null && this.state.map.hasLayer(this.findBestPuMarker)) {
        this.state.map.removeLayer(this.findBestPuMarker);
      }
      if (this.findBestPuPopup != null && this.state.map.hasLayer(this.findBestPuPopup)) {
        this.state.map.removeLayer(this.findBestPuPopup);
      }
      if (this.findBestDoMarker != null && this.state.map.hasLayer(this.findBestDoMarker)) {
        this.state.map.removeLayer(this.findBestDoMarker);
      }
      if (this.findBestDoPopup != null && this.state.map.hasLayer(this.findBestDoPopup)) {
        this.state.map.removeLayer(this.findBestDoPopup);
      }
      // this.isFindBestMode = false;
      this.findBestTripIdx = -1;
      this.findBestData = [];
      this.findBestPuMarker = null;
      this.findBestDoMarker = null;
      this.findBestPuPopup = null;
      this.findBestDoPopup = null;
      if (this.trackSelectedSegmentTimeout != null) {
        clearTimeout(this.trackSelectedSegmentTimeout);
      }
      if (this.plotSelectedSegmentCurrentLocationTimeout != null) {
        clearTimeout(this.plotSelectedSegmentCurrentLocationTimeout);
      }
      this.selectedSegmentCurrentLocation = {};
      this.selectedSegmentCurrentLocationMarker = {};
      this.trackSelectedSegmentTimeout = null;
      this.plotSelectedSegmentCurrentLocationInterval = 1;
      this.plotSelectedSegmentCurrentLocationTimeout = null;
      this.segmentsForSelectedTrips = [];
    }
  }

  mapHandleRefreshSegments() {
    if (this.state.playSegmentStatus === "play" || this.state.playSegmentStatus === "pause") {
      this.stopSegment();
    }
    this.clearSelectedSetmentFromMap();
    this.setState({
      selectedSegment: [],
      selectedSegmentPolyline: {},
      selectedSegmentPlayPolylines: [],
      playSegmentTimeOut: null,
      playSegmentVehicleMarker: null,
      playSegmentStatus: "stop"
    });
    this.state.selectedSegment = [];
    this.state.selectedSegmentPolyline = {};
    this.state.selectedSegmentPlayPolylines = [];
    this.state.playSegmentTimeOut = null;
    this.state.playSegmentVehicleMarker = null;
    this.state.playSegmentStatus = "stop";

    if (this.findBestTripIdx >= 0) {
      if (this.findBestPuMarker != null && this.state.map.hasLayer(this.findBestPuMarker)) {
        this.state.map.removeLayer(this.findBestPuMarker);
      }
      if (this.findBestPuPopup != null && this.state.map.hasLayer(this.findBestPuPopup)) {
        this.state.map.removeLayer(this.findBestPuPopup);
      }
      if (this.findBestDoMarker != null && this.state.map.hasLayer(this.findBestDoMarker)) {
        this.state.map.removeLayer(this.findBestDoMarker);
      }
      if (this.findBestDoPopup != null && this.state.map.hasLayer(this.findBestDoPopup)) {
        this.state.map.removeLayer(this.findBestDoPopup);
      }
      this.findBestTripIdx = -1;
      this.findBestData = [];
      this.findBestPuMarker = null;
      this.findBestDoMarker = null;
      this.findBestPuPopup = null;
      this.findBestDoPopup = null;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.activeTab != 1) { // Trips Tab
      console.log("Map activeTab is not 1");
      this.tempClearAllSegments();
      this.stopSegment();
      this.state.easyBar._buttons[4].button.style.display = "none";
      if (!document.getElementById("myRightBottomNav").hidden) {
        // document.getElementById("myRightBottomNav").hidden = true;
      }
      let aIsUpdateZoom = true;
      this.clearSelectedSetmentFromMap();
      if (nextProps.selectedTripsClustersRb != null && nextProps.selectedTripsClustersRb != this.state.selectedTripsClustersRb) {
        this.setState({ selectedTripsClustersRb: nextProps.selectedTripsClustersRb });
        if (nextProps.selectedTripsClustersRb != this.state.selectedTripsClustersRb) {
          this.state.selectedTripsClustersRb = nextProps.selectedTripsClustersRb;
        }
        aIsUpdateZoom = false;
      }
      if (nextProps.selectedPuDoRb != null && nextProps.selectedPuDoRb != this.state.selectedPuDoRb) {
        this.setState({ selectedPuDoRb: nextProps.selectedPuDoRb });
        if (nextProps.selectedPuDoRb != this.state.selectedPuDoRb) {
          this.state.selectedPuDoRb = nextProps.selectedPuDoRb;
        }
        aIsUpdateZoom = false;
      }
      if (nextProps.selectedTimeSlots != null && nextProps.selectedTimeSlots != this.state.selectedTimeSlots) {
        this.setState({ selectedTimeSlots: nextProps.selectedTimeSlots });
        if (nextProps.selectedTimeSlots != this.state.selectedTimeSlots) {
          this.state.selectedTimeSlots = nextProps.selectedTimeSlots;
        }
        aIsUpdateZoom = false;
      }
      if (nextProps.selectAllTimeSlots != null && nextProps.selectAllTimeSlots != this.state.selectAllTimeSlots) {
        this.setState({ selectAllTimeSlots: nextProps.selectAllTimeSlots });
        if (nextProps.selectAllTimeSlots != this.state.selectAllTimeSlots) {
          this.state.selectAllTimeSlots = nextProps.selectAllTimeSlots;
        }
        aIsUpdateZoom = false;
      }
      if (nextProps.timeSlotMin != null && nextProps.timeSlotMin != this.state.timeSlotMin) {
        this.setState({ timeSlotMin: nextProps.timeSlotMin });
        if (nextProps.timeSlotMin != this.state.timeSlotMin) {
          this.state.timeSlotMin = nextProps.timeSlotMin;
        }
        aIsUpdateZoom = false;
      }
      if (nextProps.timeSlotMax != null && nextProps.timeSlotMax != this.state.timeSlotMax) {
        this.setState({ timeSlotMax: nextProps.timeSlotMax });
        if (nextProps.timeSlotMax != this.state.timeSlotMax) {
          this.state.timeSlotMax = nextProps.timeSlotMax;
        }
        aIsUpdateZoom = false;
      }
      if (this.state.trips != nextProps.trips) {
        if (nextProps.trips != null && nextProps.trips.length != 0) {
          this.setState({ trips: nextProps.trips });
          if (this.state.trips === null || this.state.trips.length === 0) {
            this.state.trips = nextProps.trips;
          }
        } else {
          this.setState({ trips: nextProps.trips });
          this.state.trips = nextProps.trips;
        }
        if (this.state.trips != null && this.state.trips.length != 0) {
          // setTimeout(function () { this.addClustersAndPreparePolylines(); }.bind(this), 66)
          this.addClustersAndPreparePolylines();
        }
      } else {
        this.recoverTripsToMap(aIsUpdateZoom);
      }
      // if (this.isFindBestMode) {
      if (this.findBestTripIdx >= 0) {
        if (this.findBestPuMarker != null && this.state.map.hasLayer(this.findBestPuMarker)) {
          this.state.map.removeLayer(this.findBestPuMarker);
        }
        if (this.findBestPuPopup != null && this.state.map.hasLayer(this.findBestPuPopup)) {
          this.state.map.removeLayer(this.findBestPuPopup);
        }
        if (this.findBestDoMarker != null && this.state.map.hasLayer(this.findBestDoMarker)) {
          this.state.map.removeLayer(this.findBestDoMarker);
        }
        if (this.findBestDoPopup != null && this.state.map.hasLayer(this.findBestDoPopup)) {
          this.state.map.removeLayer(this.findBestDoPopup);
        }
        // this.isFindBestMode = false;
        this.findBestTripIdx = -1;
        this.findBestData = [];
        this.findBestPuMarker = null;
        this.findBestDoMarker = null;
        this.findBestPuPopup = null;
        this.findBestDoPopup = null;
        this.setState({
          selectedSegment: [],
          selectedSegmentPolyline: {},
          selectedSegmentPlayPolylines: [],
          playSegmentTimeOut: null,
          playSegmentVehicleMarker: null,
          playSegmentStatus: "stop"
        });
        this.props.getSchedulesBrief();
        this.props.clearFindBest();
        if (!document.getElementById("myRightBottomNav").hidden) {
          document.getElementById("myRightBottomNav").hidden = true;
        }
      }
    } else { // Segments Tab
      console.log("Map activeTab is 1");
      this.state.easyBar._buttons[4].button.style.display = "block";
      if (this.state.trips != nextProps.trips) {
        if (nextProps.trips != null && nextProps.trips.length != 0) {
          this.setState({ trips: nextProps.trips });
          if (this.state.trips === null || this.state.trips.length === 0) {
            this.state.trips = nextProps.trips;
          }
        }
        if (this.state.trips != null && this.state.trips.length != 0) {
          // setTimeout(function () { this.addClustersAndPreparePolylines(); }.bind(this), 66)
          this.addClustersAndPreparePolylines();
        }
      }
      this.clearTripsFromMap();
      if ((nextProps.schedulesBrief != null && nextProps.schedulesBrief.length != 0 && this.isNewSegment(nextProps.schedulesBrief, nextProps.schedules)) || (this.state.selectedSegment === null || this.state.selectedSegment.length === 0 || this.isEmptyObj(this.state.selectedSegmentPolyline))) {
        this.clearSelectedSetmentFromMap();
        this.getSelectedSegment(nextProps.schedulesBrief, nextProps.schedules);
        this.getPolylineOfSegment(this.addStopsOfSegment());
      } else {
        this.recoverSelectedSegmentToMap();
      }
    }

  }

  isNewSegment(theSchedulesBrief, theSchedules) {
    for (var i = 0; i < theSchedulesBrief.length; i++) {
      if (theSchedulesBrief[i].selected) {
        if (this.state.selectedSegment != null && this.state.selectedSegment.length != 0 && this.state.selectedSegment[0].res_num === theSchedulesBrief[i].res_num) {
          return false;
        } else {
          return true;
        }
      }
    }
    return false;
  }

  clearSelectedSetmentFromMap() {
    this.stopSegment();
    if (this.state.map.hasLayer(this.state.selectedSegmentPolyline)) {
      this.state.map.removeLayer(this.state.selectedSegmentPolyline);
    }
    for (var i = 0; i < this.state.selectedSegment.length; i++) {
      if (this.state.map.hasLayer(this.state.selectedSegment[i].marker)) {
        this.state.map.removeLayer(this.state.selectedSegment[i].marker);
      }
    }
  }

  recoverSelectedSegmentToMap() {
    if (!this.state.map.hasLayer(this.state.selectedSegmentPolyline)) {
      try {
        this.state.map.addLayer(this.state.selectedSegmentPolyline);
      } catch (e) {
        return;
      }
    }
    for (var i = 0; i < this.state.selectedSegment.length; i++) {
      if (this.state.selectedSegment[i].marker && !this.state.map.hasLayer(this.state.selectedSegment[i].marker)) {
        this.state.selectedSegment[i].marker.addTo(this.state.map);
        if (document.getElementById("myRightBottomNav").hidden) {
          document.getElementById("myRightBottomNav").hidden = false;
          window.document.getElementById("right_bottom_btn_manifest_left").hidden = true;
        }
      }
    }
    // if (!this.isFindBestMode) {
    if (this.findBestTripIdx < 0) {
      if (this.state.selectedSegmentPolyline != null && !this.isEmptyObj(this.state.selectedSegmentPolyline)) {
        // this.zoomToFeature(this.state.selectedSegmentPolyline);
      }
    } else {
      if (this.findBestDoMarker != null && this.findBestPuMarker != null) {
        this.findBestDoMarker.openPopup();
        this.findBestPuMarker.openPopup();
        this.state.map.setView([this.findBestPuMarker.getLatLng().lat, this.findBestPuMarker.getLatLng().lng], 17);
      }
    }
  }

  addStopsOfSegment() {
    let aPolylineParameter = "";
    let aPopUp = null;
    for (var i = 0; i < this.state.selectedSegment.length; i++) {
      if (this.state.selectedSegment[i].stop_type.toLowerCase() == "pickup") {
        aPopUp = L.popup({ closeButton: true, autoClose: true, className: "pu_" + this.state.selectedSegment[i].res_num + "_" + i.toString() }).setLatLng(new L.LatLng(this.state.selectedSegment[i].lat, this.state.selectedSegment[i].lng))
          .setContent(this.convertMinutesToAmPm(this.state.selectedSegment[i].triptime) + "&nbsp;&nbsp;" + this.state.selectedSegment[i].client_name);
        this.state.selectedSegment[i].marker = L.marker(
          new L.LatLng(this.state.selectedSegment[i].lat, this.state.selectedSegment[i].lng),
          { icon: marker.pu }
          // ).bindPopup(this.state.selectedSegment[i].trip_id).addTo(this.state.map);
        ).bindPopup(aPopUp).addTo(this.state.map);
      } else if (this.state.selectedSegment[i].stop_type.toLowerCase() == "dropoff") {
        aPopUp = L.popup({ closeButton: true, autoClose: true, className: "do_" + this.state.selectedSegment[i].res_num + "_" + i.toString() }).setLatLng(new L.LatLng(this.state.selectedSegment[i].lat, this.state.selectedSegment[i].lng))
          .setContent(this.convertMinutesToAmPm(this.state.selectedSegment[i].triptime) + "&nbsp;&nbsp;" + this.state.selectedSegment[i].client_name);
        this.state.selectedSegment[i].marker = L.marker(
          new L.LatLng(this.state.selectedSegment[i].lat, this.state.selectedSegment[i].lng),
          { icon: marker.do }
          // ).bindPopup(this.state.selectedSegment[i].trip_id).addTo(this.state.map);
        ).bindPopup(aPopUp).addTo(this.state.map);
      }
      if (aPolylineParameter == null || aPolylineParameter.length == 0) {
        aPolylineParameter = this.state.selectedSegment[i].lng + "," + this.state.selectedSegment[i].lat;
      } else {
        aPolylineParameter = aPolylineParameter + ";" + this.state.selectedSegment[i].lng + "," + this.state.selectedSegment[i].lat;
      }
    }
    return aPolylineParameter;
  }

  getPolylineOfSegment(thePolylineParam) {
    if (thePolylineParam == null || thePolylineParam.length == 0) {
      if (!document.getElementById("myRightBottomNav").hidden) {
        document.getElementById("myRightBottomNav").hidden = true;
      }
      return;
    }
    (function (theComponent, thePolylineParam) {
      // let aUrl = 'http://osrm5.hbssweb.com/route/v1/driving/' + thePolylineParam + '?overview=simplified&steps=true';
      let aUrl = theComponent.props.OsrmBaseUrl + thePolylineParam + '?overview=simplified&steps=true';
      fetch(aUrl)
        .then(res => res.json())
        .then(
          (result) => {
            if (result != null && result.code != null && result.code.toUpperCase() == 'OK' && result.routes != null
              && result.routes.length != 0 && result.routes[0].legs != null) {
              theComponent.showSegmentPolyline(result.routes[0]);
            }
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            theComponent.setState({
              isLoaded: true,
              error
            });
          }
        )
    })(this, thePolylineParam);
    /* let aUrl = 'http://osrm5.hbssweb.com/route/v1/driving/' + thePolylineParam + '?overview=simplified&steps=true';
    fetch(aUrl)
      .then(res => res.json())
      .then(
        (result) => {
          if (result != null && result.code != null && result.code.toUpperCase() == 'OK' && result.routes != null
            && result.routes.length != 0 && result.routes[0].legs != null) {
            this.showSegmentPolyline(result.routes[0]);
          }
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      ) */
  }

  showSegmentPolyline(theRoute) {
    let aRowSelectors = document.getElementsByClassName("ant-table-selection-column");
    for (var i = 0; i < aRowSelectors.length; i++) {
      aRowSelectors[i].style.minWidth = "8px";
      aRowSelectors[i].style.width = "16px";
      aRowSelectors[i].style.padding = "6px";
    }
    document.getElementsByClassName("ant-table-thead")[1].children[0].children[1].style.width = "117px";
    document.getElementsByClassName("ant-table-thead")[1].children[0].children[2].style.width = "57px";
    document.getElementsByClassName("ant-table-thead")[1].children[0].children[3].style.width = "57px";
    document.getElementsByClassName("ant-table-thead")[1].children[0].children[4].style.width = "57px";
    for (var i = 0; i < document.getElementsByClassName("ant-table-tbody")[2].children.length; i++) {
      document.getElementsByClassName("ant-table-tbody")[2].children[i].children[1].style.width = "117px";
      document.getElementsByClassName("ant-table-tbody")[2].children[i].children[1].children[1].style.width = "101px";
      document.getElementsByClassName("ant-table-tbody")[2].children[i].children[1].children[1].children[0].style.width = "101px";
      document.getElementsByClassName("ant-table-tbody")[2].children[i].children[2].style.width = "57px";
      document.getElementsByClassName("ant-table-tbody")[2].children[0].children[2].children[0].style.width = "40px";
      document.getElementsByClassName("ant-table-tbody")[2].children[0].children[2].children[0].children[0].style.width = "40px";
      document.getElementsByClassName("ant-table-tbody")[2].children[i].children[3].style.width = "57px";
      document.getElementsByClassName("ant-table-tbody")[2].children[i].children[3].children[0].style.width = "40px";
      document.getElementsByClassName("ant-table-tbody")[2].children[i].children[3].children[0].children[0].style.width = "40px";
      document.getElementsByClassName("ant-table-tbody")[2].children[i].children[4].style.width = "57px";
      document.getElementsByClassName("ant-table-tbody")[2].children[i].children[4].children[0].style.width = "40px";
      document.getElementsByClassName("ant-table-tbody")[2].children[i].children[4].children[0].children[0].style.width = "40px";
    }
    var polyline_points = [];
    for (var i = 0; i < theRoute.legs.length; i++) {
      for (var j = 0; j < theRoute.legs[i].steps.length; j++) {
        if (polyline_points === null || polyline_points.length === 0) {
          polyline_points = window.decodePolyline(theRoute.legs[i].steps[j].geometry, 5);
        } else {
          polyline_points = polyline_points.concat(window.decodePolyline(theRoute.legs[i].steps[j].geometry, 5));
        }
      }
    }
    this.setState({
      selectedSegmentPolyline: L.polyline(polyline_points, {
        color: 'DarkBlue',
        smoothFactor: 3.0,
        weight: 5
      })/*.bindPopup(this.state.trips[0].res_num)*/.addTo(this.state.map)
    });
    if (this.state.selectedSegmentPolyline != null && !this.isEmptyObj(this.state.selectedSegmentPolyline)) {
      this.zoomToFeature(this.state.selectedSegmentPolyline);
    }
    // if (this.isFindBestMode) {
    if (this.findBestTripIdx >= 0) {
      if (this.findBestPuMarker != null && this.state.map.hasLayer(this.findBestPuMarker)) {
        this.state.map.removeLayer(this.findBestPuMarker);
      }
      if (this.findBestDoMarker != null && this.state.map.hasLayer(this.findBestDoMarker)) {
        this.state.map.removeLayer(this.findBestDoMarker);
      }
      this.addFindBestTrip();
    }
  }

  getSelectedSegment(theSchedulesBrief, theSchedules) {
    let aTempSegment = [];
    outterloop: for (var i = 0; i < theSchedulesBrief.length; i++) {
      if (theSchedulesBrief[i].selected) {
        if (this.state.selectedSegment != null && this.state.selectedSegment.length != 0 && this.state.selectedSegment[0].res_num === theSchedulesBrief[i].res_num) {
          return false;
        }
        for (var j = 0; j < theSchedules.length; j++) {
          if (theSchedules[j].res_num === theSchedulesBrief[i].res_num) {
            aTempSegment.push(theSchedules[j]);
          } else if (aTempSegment != null && aTempSegment.length != 0) {
            break outterloop;
          }
        }
      }
    }
    // this.setState({selectedSegment: aTempSegment});
    if (this.state.selectedSegment === null || this.state.selectedSegment.length === 0 || (aTempSegment !== null && aTempSegment.length !== 0 && this.state.selectedSegment[0].res_num !== aTempSegment[0].res_num)) {
      this.selectedSegmentCurrentLocation = {};
      this.selectedSegmentCurrentLocationMarker = {};
    }
    this.state.selectedSegment = aTempSegment;
    // this.getSegmentCurrentLocation();
    return true;
  }

  clearTripsFromMap() {
    if (this.state.map.hasLayer(this.state.clusters)) {
      this.state.map.removeLayer(this.state.clusters);
    }
    for (var i = 0; i < this.state.trips.length; i++) {
      if (this.state.map.hasLayer(this.state.trips[i].polyline_drawable)) {
        this.state.map.removeLayer(this.state.trips[i].polyline_drawable);
      }
    }
    for (var i = 0; i < this.segmentsForSelectedTrips.length; i++) {
      if (this.state.map.hasLayer(this.segmentsForSelectedTrips[i].polyline)) {
        this.state.map.removeLayer(this.segmentsForSelectedTrips[i].polyline);
      }
    }
  }

  recoverTripsToMap(theIsUpdateZoom) {
    let aTempSegments = [];
    this.removeSegmentsForSelectedTrips();
    this.segmentsForSelectedTrips = [];
    let aIsSelectAll = true;
    for (var i = 0; i < this.state.trips.length; i++) {
      if (typeof this.state.trips[i].selected == "undefined" || !this.state.trips[i].selected) {
        aIsSelectAll = false;
        break;
      }
    }
    if (this.state.selectedPuDoRb === "pu") {
      for (var i = 0; i < this.state.trips.length; i++) {
        // if (this.state.selectAllTimeSlots == 2 || this.state.selectedTimeSlots[this.state.trips[i].time_slot]) {
        if (this.state.trips[i].time_slot >= this.state.timeSlotMin && this.state.trips[i].time_slot <= this.state.timeSlotMax) {
          if (this.state.clusters.hasLayer(this.state.trips[i].do_marker)) {
            this.state.clusters.removeLayer(this.state.trips[i].do_marker);
          }
          if (!this.state.clusters.hasLayer(this.state.trips[i].pu_marker)) {
            this.state.clusters.addLayer(this.state.trips[i].pu_marker);
          }
        } else {
          if (this.state.clusters.hasLayer(this.state.trips[i].pu_marker)) {
            this.state.clusters.removeLayer(this.state.trips[i].pu_marker);
          }
          if (this.state.clusters.hasLayer(this.state.trips[i].do_marker)) {
            this.state.clusters.removeLayer(this.state.trips[i].do_marker);
          }
        }
      }
    } else if (this.state.selectedPuDoRb === "do") {
      for (var i = 0; i < this.state.trips.length; i++) {
        // if (this.state.selectAllTimeSlots == 2 || this.state.selectedTimeSlots[this.state.trips[i].time_slot]) {
        if (this.state.trips[i].time_slot >= this.state.timeSlotMin && this.state.trips[i].time_slot <= this.state.timeSlotMax) {
          if (this.state.clusters.hasLayer(this.state.trips[i].pu_marker)) {
            this.state.clusters.removeLayer(this.state.trips[i].pu_marker);
          }
          if (!this.state.clusters.hasLayer(this.state.trips[i].do_marker)) {
            this.state.clusters.addLayer(this.state.trips[i].do_marker);
          }
        }
        else {
          if (this.state.clusters.hasLayer(this.state.trips[i].pu_marker)) {
            this.state.clusters.removeLayer(this.state.trips[i].pu_marker);
          }
          if (this.state.clusters.hasLayer(this.state.trips[i].do_marker)) {
            this.state.clusters.removeLayer(this.state.trips[i].do_marker);
          }
        }
      }
    } else {
      /* let aIsSelectAll = true;
      for (var i = 0; i < this.state.trips.length; i++) {
        if (typeof this.state.trips[i].selected !== "undefined" && this.state.trips[i].selected) {

        }else{
          aIsSelectAll = false;
          break;
        }
      }
      if(aIsSelectAll){
        let aIsPolylineAllLoaded = true;
        for (var i = 0; i < this.state.trips.length; i++) {
          if (typeof this.state.trips[i].polyline_drawable === "undefined" || !this.state.trips[i].polyline_drawable || this.state.trips[i].polyline_drawable ===null) {
            aIsPolylineAllLoaded = false;
            break;
          }
        }
        if(!aIsPolylineAllLoaded){
          this.loadAllPolylinesOnSelectAll();
          return;
        }else{
          // this.props.closePolylineWaitDailog();
          document.getElementsByClassName("load_polyline_wait_dialog")[0].hidden = true;
          document.getElementsByClassName("ant-modal-mask")[0].hidden = true;
        }
      } */
      for (var i = 0; i < this.state.trips.length; i++) {
        // if (this.state.selectAllTimeSlots == 2 || this.state.selectedTimeSlots[this.state.trips[i].time_slot]) {
        if (this.state.trips[i].time_slot >= this.state.timeSlotMin && this.state.trips[i].time_slot <= this.state.timeSlotMax && (typeof this.state.trips[i].selected !== "undefined" && this.state.trips[i].selected)) {
          if (!aIsSelectAll) {
            /* let aSegmentId = "";
            if (this.state.trips[i].segment_id !== null && this.state.trips[i].segment_id.length !== 0) {
              innerloop1: for (var j = 0; j < this.props.schedules.length; j++) {
                if (this.state.trips[i].segment_id === this.props.schedules[j].res_num) {
                  aSegmentId = this.state.trips[i].segment_id;
                  break innerloop1;
                }
              }
            }
            if (aSegmentId === null || aSegmentId.length === 0) {
              if (!this.state.clusters.hasLayer(this.state.trips[i].pu_marker)) {
                this.state.clusters.addLayer(this.state.trips[i].pu_marker);
              }
              if (!this.state.clusters.hasLayer(this.state.trips[i].do_marker)) {
                this.state.clusters.addLayer(this.state.trips[i].do_marker);
              }
            } else {
              aTempSegments.push(aSegmentId);
            } */
            if (this.state.trips[i].segment_id === null || this.state.trips[i].segment_id.length === 0) {
              if (!this.state.clusters.hasLayer(this.state.trips[i].pu_marker)) {
                this.state.clusters.addLayer(this.state.trips[i].pu_marker);
              }
              if (!this.state.clusters.hasLayer(this.state.trips[i].do_marker)) {
                this.state.clusters.addLayer(this.state.trips[i].do_marker);
              }
              if(!this.state.map.hasLayer(this.state.trips[i].straightLine)){
                this.state.trips[i].straightLine.addTo(this.state.map);
              }
            } else {
              if (aTempSegments == null || aTempSegments.length == 0 || aTempSegments.indexOf(this.state.trips[i].segment_id) < 0) {
                aTempSegments.push(this.state.trips[i].segment_id)
                this.segmentsForSelectedTrips.push({
                  segment_id: this.state.trips[i].segment_id,
                  pu_marker: this.state.trips[i].pu_marker,
                  do_marker: this.state.trips[i].do_marker,
                  markers: [],
                  polyline: {}
                });
              }
            }
          } else {
            if (!this.state.clusters.hasLayer(this.state.trips[i].pu_marker)) {
              this.state.clusters.addLayer(this.state.trips[i].pu_marker);
            }
            if (!this.state.clusters.hasLayer(this.state.trips[i].do_marker)) {
              this.state.clusters.addLayer(this.state.trips[i].do_marker);
            }
            if(!this.state.map.hasLayer(this.state.trips[i].straightLine)){
              this.state.trips[i].straightLine.addTo(this.state.map);
            }
          }
        }
        else {
          if (true || this.state.trips[i].segment_id === null || this.state.trips[i].segment_id.length === 0) {
            if (this.state.clusters.hasLayer(this.state.trips[i].pu_marker)) {
              this.state.clusters.removeLayer(this.state.trips[i].pu_marker);
            }
            if (this.state.clusters.hasLayer(this.state.trips[i].do_marker)) {
              this.state.clusters.removeLayer(this.state.trips[i].do_marker);
            }
            if(this.state.map.hasLayer(this.state.trips[i].straightLine)){
              this.state.map.removeLayer(this.state.trips[i].straightLine);
            }
          }
        }
      }
      /* if(aTempSegments!==null && aTempSegments.length !== 0){
      
      } */
    }
    if (!this.isEmptyObj(this.state.clusters) && this.state.clusters.getLayers() !== null && this.state.clusters.getLayers().length !== 0 && !this.state.map.hasLayer(this.state.clusters)) {
      this.state.map.addLayer(this.state.clusters);
    }
    if (this.state.selectedTripsClustersRb === "trips") {
      for (var i = 0; i < this.state.trips.length; i++) {
        // if (this.state.selectAllTimeSlots == 2 || this.state.selectedTimeSlots[this.state.trips[i].time_slot]) {
        if (this.state.trips[i].time_slot >= this.state.timeSlotMin && this.state.trips[i].time_slot <= this.state.timeSlotMax && (typeof this.state.trips[i].selected !== "undefined" && this.state.trips[i].selected)) {
          /* let bSegmentId = "";
          if (this.state.trips[i].segment_id !== null && this.state.trips[i].segment_id.length !== 0) {
            innerloop2: for (var j = 0; j < this.props.schedules.length; j++) {
              if (this.state.trips[i].segment_id === this.props.schedules[j].res_num) {
                bSegmentId = this.state.trips[i].segment_id;
                break innerloop2;
              }
            }
          }
          if(bSegmentId==null || bSegmentId.length == 0){
            if (this.state.trips[i].polyline_drawable && !this.state.map.hasLayer(this.state.trips[i].polyline_drawable)) {
              this.state.trips[i].polyline_drawable.addTo(this.state.map);
            }
          } */
          if (enablePolyline) {
            if (this.state.trips[i].polyline_drawable && !this.state.map.hasLayer(this.state.trips[i].polyline_drawable)) {
              this.state.trips[i].polyline_drawable.addTo(this.state.map);
            } else if (typeof this.state.trips[i].polyline_drawable === "undefined") {
              (function (theComponent, theIdx) {
                theComponent.getPolylineFromOsrmAndAddToMap(theIdx);
              })(this, i);
              /* (function (theComponent, theIdx) {
                theComponent.getPolylineFromOsrm(theIdx);
              })(this, i); */
            }
          }
        }
        else {
          if (this.state.trips[i].polyline_drawable && this.state.map.hasLayer(this.state.trips[i].polyline_drawable)) {
            this.state.map.removeLayer(this.state.trips[i].polyline_drawable);
          }
        }
      }
    } else if (this.state.selectedTripsClustersRb === "clusters") {
      for (var i = 0; i < this.state.trips.length; i++) {
        if (this.state.map.hasLayer(this.state.trips[i].polyline_drawable)) {
          this.state.map.removeLayer(this.state.trips[i].polyline_drawable);
        }
      }
    }
    if (!aIsSelectAll && this.segmentsForSelectedTrips !== null && this.segmentsForSelectedTrips.length != 0 && aTempSegments !== null && aTempSegments.length === this.segmentsForSelectedTrips.length) {
      theIsUpdateZoom = false;
    }
    if (theIsUpdateZoom && this.state.clusters != null && !this.isEmptyObj(this.state.clusters) && this.state.clusters.getLayers() !== null && this.state.clusters.getLayers().length !== 0) {
      if (this.previousZoom.centerLat * this.previousZoom.centerLng === 0 || (this.state.clusters.getBounds().getCenter().lat !== this.previousZoom.centerLat && this.state.clusters.getBounds().getCenter().lng !== this.previousZoom.centerLng)) {
        this.zoomToFeature(this.state.clusters);
        this.previousZoom.centerLat = this.state.clusters.getBounds().getCenter().lat;
        this.previousZoom.centerLng = this.state.clusters.getBounds().getCenter().lng;
      }
    }
    if (!aIsSelectAll && this.segmentsForSelectedTrips !== null && this.segmentsForSelectedTrips.length != 0 && aTempSegments !== null && aTempSegments.length === this.segmentsForSelectedTrips.length) {
      this.addSegmentsWithTrips(aTempSegments);
    }
  }

  removeSegmentsForSelectedTrips() {
    if (this.isEmptyObj(this.state.clusters)) {
      for (var i = 0; i < this.segmentsForSelectedTrips.length; i++) {
        if (this.state.map.hasLayer(this.segmentsForSelectedTrips[i].polyline)) {
          this.state.map.removeLayer(this.segmentsForSelectedTrips[i].polyline);
        }
      }
      this.segmentsForSelectedTrips = [];
      return;
    }
    for (var i = 0; i < this.segmentsForSelectedTrips.length; i++) {
      for (var j = 0; j < this.segmentsForSelectedTrips[i].markers.length; j++) {
        if (this.state.clusters.hasLayer(this.segmentsForSelectedTrips[i].markers[j])) {
          this.state.clusters.removeLayer(this.segmentsForSelectedTrips[i].markers[j]);
        }
      }
      if (this.state.map.hasLayer(this.segmentsForSelectedTrips[i].polyline)) {
        this.state.map.removeLayer(this.segmentsForSelectedTrips[i].polyline);
      }
    }
  }

  addSegmentsWithTrips(theSegments) {
    let aPolylineOsrmParam = "";
    for (var i = 0; i < this.segmentsForSelectedTrips.length; i++) {
      aPolylineOsrmParam = "";
      innerloop: for (var j = 0; j < this.props.schedules.length; j++) {
        if (this.props.schedules[j].res_num === theSegments[i]) {
          this.addStopsForSegmentWithTrips(i, j);
          if (aPolylineOsrmParam == null || aPolylineOsrmParam.length == 0) {
            aPolylineOsrmParam = this.props.schedules[j].lng + "," + this.props.schedules[j].lat;
          } else {
            aPolylineOsrmParam = aPolylineOsrmParam + ";" + this.props.schedules[j].lng + "," + this.props.schedules[j].lat;
          }
        } else if (aPolylineOsrmParam !== null && aPolylineOsrmParam.length !== 0) {
          break innerloop;
        }
      }
      this.getPolylineFromOsrmForSegmentsWithTrips(i, aPolylineOsrmParam);
      if (i == this.segmentsForSelectedTrips.length - 1) {
        if (this.previousZoom.centerLat * this.previousZoom.centerLng === 0 || (L.latLngBounds([this.segmentsForSelectedTrips[i].pu_marker.getLatLng()]).getCenter().lat !== this.previousZoom.centerLat && L.latLngBounds([this.segmentsForSelectedTrips[i].pu_marker.getLatLng()]).getCenter().lng !== this.previousZoom.centerLng)) {
          this.state.map.setView([this.segmentsForSelectedTrips[i].pu_marker.getLatLng().lat, this.segmentsForSelectedTrips[i].pu_marker.getLatLng().lng], 16);
          this.previousZoom.centerLat = L.latLngBounds([this.segmentsForSelectedTrips[i].pu_marker.getLatLng()]).getCenter().lat;
          this.previousZoom.centerLng = L.latLngBounds([this.segmentsForSelectedTrips[i].pu_marker.getLatLng()]).getCenter().lng;
        }
      }
    }
    if (!this.state.map.hasLayer(this.state.clusters)) {
      this.state.map.addLayer(this.state.clusters);
    }
    return;
    outterloop: for (var i = 0; i < this.state.trips.length; i++) {
      if (this.state.trips[i].time_slot >= this.state.timeSlotMin && this.state.trips[i].time_slot <= this.state.timeSlotMax && (typeof this.state.trips[i].selected !== "undefined" && this.state.trips[i].selected)) {
        if (this.state.trips[i].segment_id !== null && this.state.trips[i].segment_id.length !== 0) {
          aPolylineOsrmParam = "";
          innerloop: for (var j = 0; j < this.props.schedules.length; j++) {
            if (this.state.trips[i].segment_id === this.props.schedules[j].res_num) {
              this.addStopsForSegmentWithTrips(j);
              if (aPolylineOsrmParam == null || aPolylineOsrmParam.length == 0) {
                aPolylineOsrmParam = this.props.schedules[j].lng + "," + this.props.schedules[j].lat;
              } else {
                aPolylineOsrmParam = aPolylineOsrmParam + ";" + this.props.schedules[j].lng + "," + this.props.schedules[j].lat;
              }
            } else if (aPolylineOsrmParam !== null && aPolylineOsrmParam.length !== 0) {
              break innerloop;
            }
          }
        }
      }
    }
  }

  getPolylineFromOsrmForSegmentsWithTrips(theIdx, theParam) {
    (function (theComponent, theIdx, theParam) {
      // let aUrl = 'http://osrm5.hbssweb.com/route/v1/driving/' + theParam + '?overview=simplified&steps=true';
      let aUrl = theComponent.props.OsrmBaseUrl + theParam + '?overview=simplified&steps=true';
      fetch(aUrl)
        .then(res => res.json())
        .then(
          (result) => {
            if (result != null && result.code != null && result.code.toUpperCase() == 'OK' && result.routes != null
              && result.routes.length != 0 && result.routes[0].legs != null) {
              theComponent.showPolylineForSegmentsWithTrips(theIdx, result.routes[0]);
            }
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (error) => {
            theComponent.setState({
              isLoaded: true,
              error
            });
          }
        )
    })(this, theIdx, theParam);
  }

  showPolylineForSegmentsWithTrips(theIdx, theRoute) {
    var polyline_points = [];
    for (var i = 0; i < theRoute.legs.length; i++) {
      for (var j = 0; j < theRoute.legs[i].steps.length; j++) {
        if (polyline_points === null || polyline_points.length === 0) {
          polyline_points = window.decodePolyline(theRoute.legs[i].steps[j].geometry, 5);
        } else {
          polyline_points = polyline_points.concat(window.decodePolyline(theRoute.legs[i].steps[j].geometry, 5));
        }
      }
    }
    this.segmentsForSelectedTrips[theIdx].polyline = L.polyline(polyline_points, {
      color: 'DarkBlue',
      smoothFactor: 3.0,
      weight: 5
    }).addTo(this.state.map);
  }

  addStopsForSegmentWithTrips(theSIdx, theIdx) {
    if (this.props.schedules[theIdx].stop_type.toLowerCase() == "pickup") {
      let aPopUp = L.popup({ closeButton: true, autoClose: true, className: "pu_" + this.props.schedules[theIdx].res_num + "_" + theIdx.toString() }).setLatLng(new L.LatLng(this.props.schedules[theIdx].lat, this.props.schedules[theIdx].lng))
        .setContent(this.convertMinutesToAmPm(this.props.schedules[theIdx].triptime) + "&nbsp;&nbsp;" + this.props.schedules[theIdx].client_name);
      let aMarker = L.marker(
        new L.LatLng(this.props.schedules[theIdx].lat, this.props.schedules[theIdx].lng),
        { icon: marker.pu }
      ).bindPopup(aPopUp);
      this.segmentsForSelectedTrips[theSIdx].markers.push(aMarker);
      this.state.clusters.addLayer(this.segmentsForSelectedTrips[theSIdx].markers[this.segmentsForSelectedTrips[theSIdx].markers.length - 1]);
      /* if(this.previousZoom.centerLat*this.previousZoom.centerLng===0 || (L.latLngBounds([aMarker.getLatLng()]).getCenter().lat !== this.previousZoom.centerLat && L.latLngBounds([aMarker.getLatLng()]).getCenter().lng !== this.previousZoom.centerLng)){
        this.state.map.setView([this.props.schedules[theIdx].lat, this.props.schedules[theIdx].lng], 16);
        this.previousZoom.centerLat = L.latLngBounds([aMarker.getLatLng()]).getCenter().lat;
        this.previousZoom.centerLng = L.latLngBounds([aMarker.getLatLng()]).getCenter().lng;
      } */
    } else if (this.props.schedules[theIdx].stop_type.toLowerCase() == "dropoff") {
      let aPopUp = L.popup({ closeButton: true, autoClose: true, className: "do_" + this.props.schedules[theIdx].res_num + "_" + theIdx.toString() }).setLatLng(new L.LatLng(this.props.schedules[theIdx].lat, this.props.schedules[theIdx].lng))
        .setContent(this.convertMinutesToAmPm(this.props.schedules[theIdx].triptime) + "&nbsp;&nbsp;" + this.props.schedules[theIdx].client_name);
      let aMarker = L.marker(
        new L.LatLng(this.props.schedules[theIdx].lat, this.props.schedules[theIdx].lng),
        { icon: marker.do }
      ).bindPopup(aPopUp);
      this.segmentsForSelectedTrips[theSIdx].markers.push(aMarker);
      this.state.clusters.addLayer(this.segmentsForSelectedTrips[theSIdx].markers[this.segmentsForSelectedTrips[theSIdx].markers.length - 1]);
    }
  }

  loadAllPolylinesOnSelectAll() {
    /* this.state.loadAllPolylineWaitDialogVisible = true;
    this.setState({ loadAllPolylineWaitDialogVisible: true }); */
    Modal.info({
      className: 'load_polyline_wait_dialog',
      title: 'Preparing routes for all trips...',
      content: (
        <div>
          <Spin indicator={<AntdIcon type="loading" style={{ fontSize: 66 }} spin />} />
        </div>
      ),
      okButtonProps: { display: "none" },
      cancelButtonProps: { display: "none" },
      keyboard: false,
      visible: true
    });
    // this.props.showPolylineWaitDailog();
    for (var i = 0; i < this.state.trips.length; i++) {
      (function (theComponent, theIdx) {
        theComponent.getPolylineFromOsrmAndCloseDialogOnFinish(theIdx);
      })(this, i);
    }
  }

  getPolylineFromOsrmAndCloseDialogOnFinish(theIdx) {
    // let aUrl = 'http://osrm5.hbssweb.com/route/v1/driving/' + this.state.trips[theIdx].pu_lng + ',' + this.state.trips[theIdx].pu_lat + ';' + this.state.trips[theIdx].do_lng + ',' + this.state.trips[theIdx].do_lat + '?overview=simplified&steps=true';
    let aUrl = this.props.OsrmBaseUrl + this.state.trips[theIdx].pu_lng + ',' + this.state.trips[theIdx].pu_lat + ';' + this.state.trips[theIdx].do_lng + ',' + this.state.trips[theIdx].do_lat + '?overview=simplified&steps=true';
    fetch(aUrl)
      .then(res => res.json())
      .then(
        (result) => {
          if (result != null && result.code != null && result.code.toUpperCase() == 'OK' && result.routes != null
            && result.routes.length != 0 && result.routes[0].legs != null) {
            this.addPolylineToTrip(theIdx, result.routes[0]);
          }
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
          this.state.trips[theIdx].encoded_polyline = "err";
        }
      )
  }

  addPolylineToTrip(theIdx, theRoute) {
    if (this.state.trips == null || this.state.trips.length == 0) {
      return;
    }
    this.state.trips[theIdx].polyline_points = [];
    for (var i = 0; i < theRoute.legs.length; i++) {
      for (var j = 0; j < theRoute.legs[i].steps.length; j++) {
        if (this.state.trips[theIdx].polyline_points === null || this.state.trips[theIdx].polyline_points.length === 0) {
          this.state.trips[theIdx].polyline_points = window.decodePolyline(theRoute.legs[i].steps[j].geometry, 5);
        } else {
          this.state.trips[theIdx].polyline_points = this.state.trips[theIdx].polyline_points.concat(window.decodePolyline(theRoute.legs[i].steps[j].geometry, 5));
        }
      }
    }
    this.state.trips[theIdx].polyline_drawable = L.polyline(this.state.trips[theIdx].polyline_points, {
      color: 'DarkBlue',
      smoothFactor: 3.0,
      weight: 5
    }).bindPopup(this.state.trips[theIdx].tripid);
    this.state.trips[theIdx].encoded_polyline = window.encodePolyline(this.state.trips[theIdx].polyline_points, 5);
    this.state.trips[theIdx].polyline_points = [];

    let isAllPolylineLoaded = true;
    for (var i = 0; i < this.state.trips.length; i++) {
      // if(this.state.trips[i].polyline_drawable==null || (typeof this.state.trips[i].polyline_drawable) === "undefined" || this.isEmptyObj(this.state.trips[i].polyline_drawable ||
      if (this.state.trips[i].encoded_polyline == null || (typeof this.state.trips[i].encoded_polyline) === "undefined" || this.state.trips[i].encoded_polyline.length == 0) {
        isAllPolylineLoaded = false;
        break;
      }
    }
    if (isAllPolylineLoaded) {
      let isAllPolylineUsable = true;
      for (var i = 0; i < this.state.trips.length; i++) {
        if (this.state.trips[i].encoded_polyline !== null && (typeof this.state.trips[i].encoded_polyline) !== "undefined" && this.state.trips[i].encoded_polyline === "err") {
          this.state.trips[i].encoded_polyline = "";
          (function (theComponent, theIdx) {
            theComponent.getPolylineFromOsrmAndCloseDialogOnFinish(theIdx);
          })(this, i);
          isAllPolylineUsable = false;
        }
      }
      if (isAllPolylineUsable) {
        // this.props.closePolylineWaitDailog();
        document.getElementsByClassName("load_polyline_wait_dialog")[0].hidden = true;
        document.getElementsByClassName("ant-modal-mask")[0].hidden = true;
        this.recoverTripsToMap(true);
      }
    }
  }

  addClustersAndPreparePolylines() {
    if (this.state.clusters && this.state.map.hasLayer(this.state.map)) {
      return;
    }
    this.state.clusters = L.markerClusterGroup({ zoomToBoundsOnClick: true });
    this.state.map.addLayer(this.state.clusters);
    let aTempClusters = L.markerClusterGroup();
    for (var i = 0; i < this.state.trips.length; i++) {
      if (this.state.clusters.hasLayer(L.marker(new L.LatLng(this.state.trips[i].pu_lat, this.state.trips[i].pu_lng), { icon: marker.pu }).bindPopup('PU of ' + this.state.trips[i].trip_id))) {
        continue;
      }
      this.state.trips[i].pu_marker = L.marker(new L.LatLng(this.state.trips[i].pu_lat, this.state.trips[i].pu_lng), { icon: marker.pu }).bindPopup('PU of ' + this.state.trips[i].trip_id);
      this.state.trips[i].do_marker = L.marker(new L.LatLng(this.state.trips[i].do_lat, this.state.trips[i].do_lng), { icon: marker.do }).bindPopup('Do of ' + this.state.trips[i].trip_id)
      // if ((this.state.selectedPuDoRb === "pu" || this.state.selectedPuDoRb === "pudo") && (this.state.selectAllTimeSlots == 2 || this.state.selectedTimeSlots[this.state.trips[i].time_slot])) {
      if ((this.state.selectedPuDoRb === "pu" || this.state.selectedPuDoRb === "pudo") && (this.state.trips[i].time_slot >= this.state.timeSlotMin && this.state.trips[i].time_slot <= this.state.timeSlotMax) && (typeof this.state.trips[i].selected !== "undefined" && this.state.trips[i].selected)) {
        this.state.clusters.addLayer(this.state.trips[i].pu_marker);
      }
      aTempClusters.addLayer(this.state.trips[i].pu_marker);
      // if ((this.state.selectedPuDoRb === "do" || this.state.selectedPuDoRb === "pudo") && (this.state.selectAllTimeSlots == 2 || this.state.selectedTimeSlots[this.state.trips[i].time_slot])) {
      if ((this.state.selectedPuDoRb === "do" || this.state.selectedPuDoRb === "pudo") && (this.state.trips[i].time_slot >= this.state.timeSlotMin && this.state.trips[i].time_slot <= this.state.timeSlotMax) && (typeof this.state.trips[i].selected !== "undefined" && this.state.trips[i].selected)) {
        this.state.clusters.addLayer(this.state.trips[i].do_marker);
      }
      aTempClusters.addLayer(this.state.trips[i].do_marker);
      let aColor = "Blue";
      if(!this.state.trips[i].trip_direction.toLowerCase().indexOf("out")){
        aColor = "Red";
      }
      this.state.trips[i].straightLine = L.polyline([[this.state.trips[i].pu_lat, this.state.trips[i].pu_lng],[this.state.trips[i].do_lat, this.state.trips[i].do_lng]], {
        color: aColor,
        smoothFactor: 3.0,
        weight: 2
      }).bindPopup(this.state.trips[i].trip_id);
      // this.state.trips[i].straightLine.addTo(this.state.map);
      /* (function (theComponent, theIdx) {
        theComponent.getPolylineFromOsrm(theIdx);
      })(this, i); */
    }
    if (this.state.clusters != null && !this.isEmptyObj(this.state.clusters) && this.state.clusters.getLayers() !== null && this.state.clusters.getLayers().length !== 0) {
      this.zoomToFeature(this.state.clusters);
    } else if (aTempClusters != null && !this.isEmptyObj(aTempClusters) && aTempClusters.getLayer() != null && aTempClusters.getLayer().length != 0) {
      this.zoomToFeature(aTempClusters);
    }
  }

  addClusters() {
    this.state.clusters = L.markerClusterGroup({ zoomToBoundsOnClick: true });
    this.state.map.addLayer(this.state.clusters);
    for (var i = 0; i < this.state.trips.length; i++) {
      if (this.state.trips[i].stoptype === 'P') {
        this.state.clusters.addLayer(L.marker(new L.LatLng(this.state.trips[i].lat, this.state.trips[i].lon), { icon: marker.pu, title: this.state.trips[i].tripid }).bindPopup('Stop of ' + this.state.trips[i].tripid));
      } else {
        this.state.clusters.addLayer(L.marker(new L.LatLng(this.state.trips[i].lat, this.state.trips[i].lon), { icon: marker.do, title: this.state.trips[i].tripid }).bindPopup('Stop of ' + this.state.trips[i].tripid));
      }
    }
    if (this.state.clusters != null && !this.isEmptyObj(this.state.clusters) && this.state.clusters.getLayers() !== null && this.state.clusters.getLayers().length !== 0) {
      this.zoomToFeature(this.state.clusters);
    }
    this.preparePolylines();
  }

  preparePolylines() {
    for (var i = 0; i < this.state.trips.length; i++) {
      if (this.state.trips[i].stoptype === 'P') {
        for (var j = 0; j < this.state.trips.length; j++) {
          if (this.state.trips[j].stoptype === 'D' && this.state.trips[j].tripid === this.state.trips[i].tripid) {
            (function (theComponent, thePuIdx, theDoIdx) {
              theComponent.getPolylineFromOsrm_NIU(thePuIdx, theDoIdx);
            })(this, i, j);
          }
        }
      }
    }
  }

  getPolylineFromOsrmAndAddToMap(theIdx) {
    // let aUrl = 'http://osrm5.hbssweb.com/route/v1/driving/' + this.state.trips[theIdx].pu_lng + ',' + this.state.trips[theIdx].pu_lat + ';' + this.state.trips[theIdx].do_lng + ',' + this.state.trips[theIdx].do_lat + '?overview=simplified&steps=true';
    let aUrl = this.props.OsrmBaseUrl + this.state.trips[theIdx].pu_lng + ',' + this.state.trips[theIdx].pu_lat + ';' + this.state.trips[theIdx].do_lng + ',' + this.state.trips[theIdx].do_lat + '?overview=simplified&steps=true';
    fetch(aUrl)
      .then(res => res.json())
      .then(
        (result) => {
          if (result != null && result.code != null && result.code.toUpperCase() == 'OK' && result.routes != null
            && result.routes.length != 0 && result.routes[0].legs != null) {
            this.addPolylineToMap(theIdx, result.routes[0]);
          }
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
          this.state.trips[theIdx].encoded_polyline = "err";
        }
      )
  }

  addPolylineToMap(theIdx, theRoute) {
    if (this.state.trips == null || this.state.trips.length == 0) {
      return;
    }
    this.state.trips[theIdx].polyline_points = [];
    for (var i = 0; i < theRoute.legs.length; i++) {
      for (var j = 0; j < theRoute.legs[i].steps.length; j++) {
        if (this.state.trips[theIdx].polyline_points === null || this.state.trips[theIdx].polyline_points.length === 0) {
          this.state.trips[theIdx].polyline_points = window.decodePolyline(theRoute.legs[i].steps[j].geometry, 5);
        } else {
          this.state.trips[theIdx].polyline_points = this.state.trips[theIdx].polyline_points.concat(window.decodePolyline(theRoute.legs[i].steps[j].geometry, 5));
        }
      }
    }
    this.state.trips[theIdx].polyline_drawable = L.polyline(this.state.trips[theIdx].polyline_points, {
      color: 'DarkBlue',
      smoothFactor: 3.0,
      weight: 5
    }).bindPopup(this.state.trips[theIdx].tripid);
    // if (this.state.selectedTripsClustersRb === "trips" && (this.state.selectAllTimeSlots == 2 || this.state.selectedTimeSlots[this.state.trips[theIdx].time_slot])) {
    if (this.state.selectedTripsClustersRb === "trips" && (this.state.trips[theIdx].time_slot >= this.state.timeSlotMin && this.state.trips[theIdx].time_slot <= this.state.timeSlotMax) && (typeof this.state.trips[theIdx].selected !== "undefined" && this.state.trips[theIdx].selected)) {
      this.state.trips[theIdx].polyline_drawable.addTo(this.state.map);
    }
    this.state.trips[theIdx].encoded_polyline = window.encodePolyline(this.state.trips[theIdx].polyline_points, 5);
    this.state.trips[theIdx].polyline_points = [];
  }

  getPolylineFromOsrm(theIdx) {
    // let aUrl = 'http://osrm5.hbssweb.com/route/v1/driving/' + this.state.trips[theIdx].pu_lng + ',' + this.state.trips[theIdx].pu_lat + ';' + this.state.trips[theIdx].do_lng + ',' + this.state.trips[theIdx].do_lat + '?overview=simplified&steps=true';
    let aUrl = this.props.OsrmBaseUrl + this.state.trips[theIdx].pu_lng + ',' + this.state.trips[theIdx].pu_lat + ';' + this.state.trips[theIdx].do_lng + ',' + this.state.trips[theIdx].do_lat + '?overview=simplified&steps=true';
    fetch(aUrl)
      .then(res => res.json())
      .then(
        (result) => {
          if (result != null && result.code != null && result.code.toUpperCase() == 'OK' && result.routes != null
            && result.routes.length != 0 && result.routes[0].legs != null) {
            this.showPolyline(theIdx, result.routes[0]);
          }
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
          this.state.trips[theIdx].encoded_polyline = "err";
        }
      )
  }

  showPolyline(theIdx, theRoute) {
    if (this.state.trips == null || this.state.trips.length == 0) {
      return;
    }
    this.state.trips[theIdx].polyline_points = [];
    for (var i = 0; i < theRoute.legs.length; i++) {
      for (var j = 0; j < theRoute.legs[i].steps.length; j++) {
        if (this.state.trips[theIdx].polyline_points === null || this.state.trips[theIdx].polyline_points.length === 0) {
          this.state.trips[theIdx].polyline_points = window.decodePolyline(theRoute.legs[i].steps[j].geometry, 5);
        } else {
          this.state.trips[theIdx].polyline_points = this.state.trips[theIdx].polyline_points.concat(window.decodePolyline(theRoute.legs[i].steps[j].geometry, 5));
        }
      }
    }
    this.state.trips[theIdx].polyline_drawable = L.polyline(this.state.trips[theIdx].polyline_points, {
      color: 'DarkBlue',
      smoothFactor: 3.0,
      weight: 5
    }).bindPopup(this.state.trips[theIdx].tripid);
    // if (this.state.selectedTripsClustersRb === "trips" && (this.state.selectAllTimeSlots == 2 || this.state.selectedTimeSlots[this.state.trips[theIdx].time_slot])) {
    if (this.state.selectedTripsClustersRb === "trips" && (this.state.trips[theIdx].time_slot >= this.state.timeSlotMin && this.state.trips[theIdx].time_slot <= this.state.timeSlotMax) && (typeof this.state.trips[theIdx].selected !== "undefined" && this.state.trips[theIdx].selected)) {
      this.state.trips[theIdx].polyline_drawable.addTo(this.state.map);
    }
    this.state.trips[theIdx].encoded_polyline = window.encodePolyline(this.state.trips[theIdx].polyline_points, 5);
    this.state.trips[theIdx].polyline_points = [];

    let isAllPolylineLoaded = true;
    for (var i = 0; i < this.state.trips.length; i++) {
      // if(this.state.trips[i].polyline_drawable==null || (typeof this.state.trips[i].polyline_drawable) === "undefined" || this.isEmptyObj(this.state.trips[i].polyline_drawable ||
      if (this.state.trips[i].encoded_polyline == null || (typeof this.state.trips[i].encoded_polyline) === "undefined" || this.state.trips[i].encoded_polyline.length == 0) {
        isAllPolylineLoaded = false;
        break;
      }
    }
    if (isAllPolylineLoaded) {
      let isAllPolylineUsable = true;
      for (var i = 0; i < this.state.trips.length; i++) {
        if (this.state.trips[i].encoded_polyline !== null && (typeof this.state.trips[i].encoded_polyline) !== "undefined" && this.state.trips[i].encoded_polyline === "err") {
          this.state.trips[i].encoded_polyline = "";
          (function (theComponent, theIdx) {
            theComponent.getPolylineFromOsrm(theIdx);
          })(this, i);
          isAllPolylineUsable = false;
        }
      }
      if (isAllPolylineUsable) {
        this.props.handleTripsPolylineLoadingCompleted();
      }
    }
  }

  getPolylineFromOsrm_NIU(thePuIdx, theDoIdx) {
    // let aUrl = 'http://osrm5.hbssweb.com/route/v1/driving/' + this.state.trips[thePuIdx].lon + ',' + this.state.trips[thePuIdx].lat + ';' + this.state.trips[theDoIdx].lon + ',' + this.state.trips[theDoIdx].lat + '?overview=simplified&steps=true';
    let aUrl = this.props.OsrmBaseUrl + this.state.trips[thePuIdx].lon + ',' + this.state.trips[thePuIdx].lat + ';' + this.state.trips[theDoIdx].lon + ',' + this.state.trips[theDoIdx].lat + '?overview=simplified&steps=true';
    fetch(aUrl)
      .then(res => res.json())
      .then(
        (result) => {
          if (result != null && result.code != null && result.code.toUpperCase() == 'OK' && result.routes != null
            && result.routes.length != 0 && result.routes[0].legs != null) {
            this.showPolyline_NIU(thePuIdx, result.routes[0]);
          }
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  showPolyline_NIU(thePuIdx, theRoute) {
    // this.state.trips[thePuIdx].encoded_polylines = [];
    this.state.trips[thePuIdx].polyline_points = [];
    for (var i = 0; i < theRoute.legs.length; i++) {
      for (var j = 0; j < theRoute.legs[i].steps.length; j++) {
        // this.state.trips[thePuIdx].encoded_polylines.push(theRoute.legs[i].steps[j].geometry);
        if (this.state.trips[thePuIdx].polyline_points === null || this.state.trips[thePuIdx].polyline_points.length === 0) {
          this.state.trips[thePuIdx].polyline_points = window.decodePolyline(theRoute.legs[i].steps[j].geometry, 5);
        } else {
          this.state.trips[thePuIdx].polyline_points = this.state.trips[thePuIdx].polyline_points.concat(window.decodePolyline(theRoute.legs[i].steps[j].geometry, 5));
        }
      }
    }
    this.state.trips[thePuIdx].polyline_drawable = L.polyline(this.state.trips[thePuIdx].polyline_points, {
      color: 'DarkBlue',
      smoothFactor: 3.0,
      weight: 5
    }).bindPopup(this.state.trips[thePuIdx].tripid).addTo(this.state.map);
    this.state.trips[thePuIdx].encoded_polyline = window.encodePolyline(this.state.trips[thePuIdx].polyline_points, 5);
    this.state.trips[thePuIdx].polyline_points = [];
  }

  componentDidUpdate(prevProps, prevState) {
    // code to run when the component receives new props or state

  }

  componentWillUnmount() {
    // code to run just before unmounting the component
    // this destroys the Leaflet map object & related event listeners
    this.state.map.remove();
  }

  zoomToMarkers(theMarkers) {
    var aGroup = L.featureGroup(theMarkers);
    this.zoomToFeature(aGroup);
  }

  zoomToFeature(target) {
    // pad fitBounds() so features aren't hidden under the Filter UI element
    var fitBoundsParams = {
      paddingTopLeft: [200, 6],
      paddingBottomRight: [10, 18]
    };
    // set the map's center & zoom so that it fits the geographic extent of the layer
    this.state.map.fitBounds(target.getBounds(), fitBoundsParams);
    if (this.state.map.getZoom() > 15) {
      this.state.map.setZoom(15);
    }
  }

  init(id) {
    if (this.state.map) return;
    if (!document.getElementById("myRightTopNav").hidden) {
      document.getElementById("myRightTopNav").hidden = true;
    }
    // this function creates the Leaflet map object and is called after the Map component mounts
    // let map = L.map(id, config.params);
    // L.control.zoom({ position: "topleft" }).addTo(map);
    // L.control.scale({ position: "topleft"}).addTo(map);
    // config.tileLayer.params.attribution = config.tileLayer.params.attribution + this.props.appVersion;
    // a TileLayer is used as the "basemap"
    // const tileLayer = L.tileLayer(configSatellite.tileLayer.uri, configSatellite.tileLayer.params).addTo(map);

    // const tileLayer   = L.tileLayer(config.tileLayer.uri, config.tileLayer.params);//.addTo(map);
    // const tileSatelliteLayer = L.tileLayer(configSatellite.tileLayer.uri, configSatellite.tileLayer.params);//.addTo(map);
    L.Map = L.Map.extend({
      openPopup: function (popup) {
        // this.closePopup();  // just comment this
        if (popup._latlng == null || typeof popup._latlng == "undefined") {
          popup._latlng = popup._source._latlng;
        }
        this._popup = popup;
        return this.addLayer(popup).fire('popupopen', {
          popup: this._popup
        });
      }
    });// end of hack

    config.params.layers = tileLayer;
    // let map = L.map(id, config.params);

    let map = new L.Map('map', config.params);

    var baseLayers = {
      "Open Street": tileLayer,
      "Satellite": tileSatelliteLayer
    };

    // L.control.layers(baseLayers, null, {position: 'topleft'}).addTo(map);
    L.control.zoom({ position: "topleft" }).addTo(map);

    // set our state to include the tile layer
    // this.setState({ map: map, tileLayer: tileLayer });
    this.state.map = map;
    // this.state.tileLayer = tileLayer;
    this.addEasyBtns(map);

    document.getElementsByClassName("leaflet-top leaflet-left")[0].style.top = '56px';
  }

  addEasyBtns(theMap) {
    let aShowHideTripsRoutesBtn = L.easyButton('fa-bars fa-lg', function () {
      this.showHideTripsRoutesSegments();
    }.bind(this), 'Trips/Routes');
    let aShowHideSchedulingOrderBtn = L.easyButton('fa-cog fa-lg', function () {
      this.showHideSchedulingOrder();
    }.bind(this), 'Schedule Rides');
    let aOpenStreetMapBtn = L.easyButton('fa fa-map-o', function () {
      this.showOpenStreetMap();
    }.bind(this), 'OpenStreet Map');
    let aSatelliteMapBtn = L.easyButton('fa fa-map', function () {
      this.showSatelliteMap();
    }.bind(this), 'Satellite Map');
    let aPlaySegmentBtn = L.easyButton('fa fa-play', function () {
      this.playSegment();
    }.bind(this), 'Play');
    let aPauseSegmentBtn = L.easyButton('fa fa-pause', function () {
      this.pauseSegment();
    }.bind(this), 'Pause');
    let aStopSegmentBtn = L.easyButton('fa fa-stop', function () {
      this.stopSegment();
    }.bind(this), 'Stop');
    this.state.easyBar = L.easyBar([aShowHideTripsRoutesBtn, aShowHideSchedulingOrderBtn, aOpenStreetMapBtn, aSatelliteMapBtn, aPlaySegmentBtn, aPauseSegmentBtn, aStopSegmentBtn]).addTo(theMap);
    this.state.easyBar._buttons[0].button.style.display = "none";
    this.state.easyBar._buttons[1].button.style.display = "none";
    this.state.easyBar._buttons[2].button.style.display = "none";
    this.state.easyBar._buttons[3].button.style.display = "block";
    this.state.easyBar._buttons[4].button.style.display = "none";
    this.state.easyBar._buttons[5].button.style.display = "none";
    this.state.easyBar._buttons[6].button.style.display = "none";
  }

  showOpenStreetMap() {
    this.state.easyBar._buttons[2].button.style.display = "none";
    this.state.easyBar._buttons[3].button.style.display = "block";
    this.state.map.removeLayer(tileSatelliteLayer);
    this.state.map.addLayer(tileLayer);
  }

  showSatelliteMap() {
    this.state.easyBar._buttons[2].button.style.display = "block";
    this.state.easyBar._buttons[3].button.style.display = "none";
    this.state.map.removeLayer(tileLayer);
    this.state.map.addLayer(tileSatelliteLayer);
  }

  pauseSegment() {
    if (this.state.playSegmentStatus === "play") {
      this.state.easyBar._buttons[4].button.style.display = "block";
      this.state.easyBar._buttons[5].button.style.display = "none";
      this.state.easyBar._buttons[6].button.style.display = "block";
      this.setState({ playSegmentStatus: "pause" });
      if (this.state.playSegmentStatus != "pause") {
        this.state.playSegmentStatus = "pause"
      }
    }
  }

  stopSegment() {
    if (this.state.playSegmentStatus !== "stop") {
      this.state.easyBar._buttons[4].button.style.display = "block";
      this.state.easyBar._buttons[5].button.style.display = "none";
      this.state.easyBar._buttons[6].button.style.display = "none";
      this.state.easyBar._buttons[4].button.style.display = "block";
      this.state.easyBar._buttons[5].button.style.display = "none";
      this.state.easyBar._buttons[6].button.style.display = "none";
      this.setState({ playSegmentStatus: "stop" });
      if (this.state.playSegmentStatus != "stop") {
        this.state.playSegmentStatus = "stop"
      }
      if (this.state.playSegmentTimeOut != null) {
        clearTimeout(this.state.playSegmentTimeOut);
      }
      /* if (!this.state.map.hasLayer(this.state.selectedSegmentPolyline)) {
        this.state.selectedSegmentPolyline.addTo(this.state.map);
      } */
      this.state.selectedSegmentPolyline.setStyle({
        color: 'DarkBlue'
      });
      while (this.state.map.hasLayer(this.state.playSegmentVehicleMarker)) {
        this.state.map.removeLayer(this.state.playSegmentVehicleMarker);
      }
      while (this.state.selectedSegmentPlayPolylines.length > 0) {
        while (this.state.map.hasLayer(this.state.selectedSegmentPlayPolylines[0])) {
          this.state.map.removeLayer(this.state.selectedSegmentPlayPolylines[0]);
        }
        this.state.selectedSegmentPlayPolylines.shift();
      }
      this.setState({ playSegmentVehicleMarker: null });
    }
  }

  showHideTripsRoutesSegments() {
    if (document.getElementById("myLeftSidenav").hidden) {
      document.getElementById("myLeftSidenav").hidden = false;
    } else {
      document.getElementById("myLeftSidenav").hidden = true;
    }
    if (document.getElementById("myRightBottomNav").hidden) {
      document.getElementById("myRightBottomNav").hidden = false;
    } else {
      document.getElementById("myRightBottomNav").hidden = true;
    }
  }

  showHideSchedulingOrder() {
    if (document.getElementById("myRightTopNav").hidden) {
      document.getElementById("myRightTopNav").hidden = false;
    } else {
      document.getElementById("myRightTopNav").hidden = true;
    }
  }

  playSegment() {
    this.state.easyBar._buttons[4].button.style.display = "none";
    this.state.easyBar._buttons[5].button.style.display = "block";
    this.state.easyBar._buttons[6].button.style.display = "block";
    if (this.state.playSegmentStatus === "stop" && this.state.selectedSegmentPolyline.getLatLngs().length > this.state.playSegmentPoints) {
      /* if (this.state.map.hasLayer(this.state.selectedSegmentPolyline)) {
        this.state.map.removeLayer(this.state.selectedSegmentPolyline);
      } */
      this.state.selectedSegmentPolyline.setStyle({
        color: 'LightSkyBlue'
      });
      while (this.state.selectedSegmentPlayPolylines.length > 0) {
        while (this.state.map.hasLayer(this.state.selectedSegmentPlayPolylines[0])) {
          this.state.map.removeLayer(this.state.selectedSegmentPlayPolylines[0]);
        }
        this.state.selectedSegmentPlayPolylines.shift();
      }
      this.setState({ playSegmentStatus: "play" });
      if (this.state.playSegmentStatus != "play") {
        this.state.playSegmentStatus = "play"
      }
      this.playSegmentPolyline(0);
    } else if (this.state.playSegmentStatus === "pause") {
      this.setState({ playSegmentStatus: "play" });
      if (this.state.playSegmentStatus != "play") {
        this.state.playSegmentStatus = "play"
      }
    }
  }

  playSegmentPolyline(theIdx) {
    let aIdx = theIdx;
    if (this.state.playSegmentTimeOut != null) {
      // window.clearTimeout(this.state.playSegmentTimeOut);
      clearTimeout(this.state.playSegmentTimeOut);
    }
    if (this.state.playSegmentStatus === "pause") {
      this.state.playSegmentTimeOut = setTimeout(function () { this.playSegmentPolyline(theIdx); }.bind(this), this.state.playSegmentInterval)
      return;
    }
    if (this.state.playSegmentStatus === "stop") {
      this.state.easyBar._buttons[4].button.style.display = "block";
      this.state.easyBar._buttons[5].button.style.display = "none";
      this.state.easyBar._buttons[6].button.style.display = "none";
      this.state.easyBar._buttons[4].button.style.display = "block";
      this.state.easyBar._buttons[5].button.style.display = "none";
      this.state.easyBar._buttons[6].button.style.display = "none";
      /* if (!this.state.map.hasLayer(this.state.selectedSegmentPolyline)) {
        this.state.selectedSegmentPolyline.addTo(this.state.map);
      } */
      this.state.selectedSegmentPolyline.setStyle({
        color: 'DarkBlue'
      });
      while (this.state.map.hasLayer(this.state.playSegmentVehicleMarker)) {
        this.state.map.removeLayer(this.state.playSegmentVehicleMarker);
      }
      while (this.state.selectedSegmentPlayPolylines.length > 0) {
        while (this.state.map.hasLayer(this.state.selectedSegmentPlayPolylines[0])) {
          this.state.map.removeLayer(this.state.selectedSegmentPlayPolylines[0]);
        }
        this.state.selectedSegmentPlayPolylines.shift();
      }
      this.setState({ playSegmentVehicleMarker: null });
      return;
    }
    let aPoints = [];
    let aSelectedSegmentPolyline = null;
    for (var i = theIdx; i < (this.state.selectedSegmentPolyline.getLatLngs().length >= theIdx + this.state.playSegmentPoints ? theIdx + this.state.playSegmentPoints : this.state.selectedSegmentPolyline.getLatLngs().length); i++) {
      aPoints.push(this.state.selectedSegmentPolyline.getLatLngs()[i]);
      aIdx = i;
    }
    if (this.state.playSegmentVehicleMarker == null) {
      this.state.playSegmentVehicleMarker = L.marker(new L.LatLng(aPoints[0].lat, aPoints[0].lng), { icon: marker.vehicle, title: this.state.trips[0].tripid }).bindPopup('Vehicle of ' + this.state.trips[0].tripid).addTo(this.state.map);
    }
    this.state.playSegmentVehicleMarker.move();
    aSelectedSegmentPolyline = L.polyline(aPoints, {
      color: 'DarkBlue',
      smoothFactor: 3.0,
      weight: 5
    }).bindPopup(this.state.trips[0].res_num).addTo(this.state.map);
    this.state.playSegmentVehicleMarker.setLatLng(new L.LatLng(aPoints[aPoints.length - 1].lat, aPoints[aPoints.length - 1].lng));
    let aPreviousSelectedSegmentPolylines = this.state.selectedSegmentPlayPolylines;
    aPreviousSelectedSegmentPolylines.push(aSelectedSegmentPolyline)
    this.setState({ selectedSegmentPlayPolylines: aPreviousSelectedSegmentPolylines });
    if (aIdx + 1 < this.state.selectedSegmentPolyline.getLatLngs().length) {
      this.state.playSegmentTimeOut = setTimeout(function () { this.playSegmentPolyline(aIdx); }.bind(this), this.state.playSegmentInterval)
    } else {
      this.state.easyBar._buttons[4].button.style.display = "block";
      this.state.easyBar._buttons[5].button.style.display = "none";
      this.state.easyBar._buttons[6].button.style.display = "none";
      /* if (!this.state.map.hasLayer(this.state.selectedSegmentPolyline)) {
        this.state.selectedSegmentPolyline.addTo(this.state.map);
      } */
      this.state.selectedSegmentPolyline.setStyle({
        color: 'DarkBlue'
      });
      while (this.state.map.hasLayer(this.state.playSegmentVehicleMarker)) {
        this.state.map.removeLayer(this.state.playSegmentVehicleMarker);
      }
      while (this.state.selectedSegmentPlayPolylines.length > 0) {
        while (this.state.map.hasLayer(this.state.selectedSegmentPlayPolylines[0])) {
          this.state.map.removeLayer(this.state.selectedSegmentPlayPolylines[0]);
        }
        this.state.selectedSegmentPlayPolylines.shift();
      }
      this.setState({ playSegmentVehicleMarker: null });
      this.setState({ playSegmentStatus: "stop" });
      if (this.state.playSegmentStatus != "stop") {
        this.state.playSegmentStatus = "stop"
      }
    }
  }

  getSegmentCurrentLocation() {
    if (this.trackSelectedSegmentTimeout != null) {
      clearTimeout(this.trackSelectedSegmentTimeout);
    }
    if (this.plotSelectedSegmentCurrentLocationTimeout != null) {
      clearTimeout(this.plotSelectedSegmentCurrentLocationTimeout);
    }
    if (this.state.selectedSegment === null || this.state.selectedSegment.length === 0) {
      return;
    }
    let aContext = this;
    let aUrl = this.props.QRydeMappBaseUrl + '613GetLastLocation?data=' + this.props.selectedDate + colSep + this.props.userName + colSep + this.state.selectedSegment[0].res_num;
    fetch(aUrl)
      .then(res => res.json())
      .then(
        (result) => {
          if (result !== null && !aContext.isEmptyObj(result) && result.cmd_name !== null && result.cmd_name === '613GetLastLocation' &&
            result.status !== null && result.status === 'OK' && result.result !== null && !aContext.isEmptyObj(result.result) &&
            (aContext.selectedSegmentCurrentLocation === null || aContext.isEmptyObj(aContext.selectedSegmentCurrentLocation) || parseInt(result.result.adid) > parseInt(aContext.selectedSegmentCurrentLocation.adid)) &&
            result.result.runid === aContext.state.selectedSegment[0].res_num && result.result.lat !== null && (typeof result.result.lat) !== "undefined" &&
            result.result.lat.length !== 0 && result.result.lng !== null && (typeof result.result.lng) !== "undefined" && result.result.lng.length !== 0) {
            try {
              if (parseFloat(result.result.lat) * parseFloat(result.result.lng) !== 0) {
                aContext.selectedSegmentCurrentLocation = result.result;
                aContext.showSegmentCurrentLocation()
              }
            } catch (e) {

            }
          }
          aContext.trackSelectedSegmentTimeout = setTimeout(function () { aContext.getSegmentCurrentLocation(); }.bind(aContext), aContext.trackSelectedSegmentInterval * 1000);
        },
        (error) => {
          aContext.trackSelectedSegmentTimeout = setTimeout(function () { aContext.getSegmentCurrentLocation(); }.bind(aContext), aContext.trackSelectedSegmentInterval * 1000);
        }
      )
  }

  showSegmentCurrentLocation() {
    let aPopupContent = "";
    if (this.selectedSegmentCurrentLocation.address !== null && this.selectedSegmentCurrentLocation.address.length !== 0) {
      aPopupContent = '<b>' + this.selectedSegmentCurrentLocation.record_time + '</b></br><font size="3">' + this.selectedSegmentCurrentLocation.runid + ' at ' + this.selectedSegmentCurrentLocation.address + '.</font>';
    } else {
      aPopupContent = '<b style="font-size:18px">' + this.selectedSegmentCurrentLocation.runid + '</b><font size="3"> at ' + this.selectedSegmentCurrentLocation.record_time + '</font>';
    }
    if (this.selectedSegmentCurrentLocationMarker === null || this.isEmptyObj(this.selectedSegmentCurrentLocationMarker)) {
      this.selectedSegmentCurrentLocationMarker = L.marker(new L.LatLng(parseFloat(this.selectedSegmentCurrentLocation.lat), parseFloat(this.selectedSegmentCurrentLocation.lng)), { icon: marker.current_location, title: aPopupContent }).bindPopup(aPopupContent).addTo(this.state.map);
      return;
    }
    this.getSegmentMovePolyline();
  }

  getSegmentMovePolyline() {
    let aPolylineParam = this.selectedSegmentCurrentLocationMarker.getLatLng().lng + "," + this.selectedSegmentCurrentLocationMarker.getLatLng().lat + ";" + this.selectedSegmentCurrentLocation.lng + "," + this.selectedSegmentCurrentLocation.lat
    let aContext = this;
    // let aUrl = 'http://osrm5.hbssweb.com/route/v1/driving/' + aPolylineParam + '?overview=simplified&steps=true';
    let aUrl = this.props.OsrmBaseUrl + aPolylineParam + '?overview=simplified&steps=true';
    fetch(aUrl)
      .then(res => res.json())
      .then(
        (result) => {
          if (result != null && result.code != null && result.code.toUpperCase() == 'OK' && result.routes != null
            && result.routes.length != 0 && result.routes[0].geometry != null) {
            let aPoints = window.decodePolyline(result.routes[0].geometry, 5);
            if (aPoints !== null && aPoints.length !== 0) {
              aContext.plotSelectedSegmentCurrentLocationInterval = aContext.trackSelectedSegmentInterval / aPoints.length;
              aContext.moveSelectedSegment(0, aPoints);
            }
          }

        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {

        }
      )
  }

  moveSelectedSegment(theIdx, theRoutePoints) {
    if (this.plotSelectedSegmentCurrentLocationTimeout != null) {
      clearTimeout(this.plotSelectedSegmentCurrentLocationTimeout);
    }
    if (theIdx < theRoutePoints.length) {
      this.selectedSegmentCurrentLocationMarker.setLatLng(new L.LatLng(theRoutePoints[theIdx][0], theRoutePoints[theIdx][1]));
      let aNextIdx = theIdx + 1;
      this.plotSelectedSegmentCurrentLocationTimeout = setTimeout(function () { this.moveSelectedSegment(aNextIdx, theRoutePoints); }.bind(this), this.plotSelectedSegmentCurrentLocationInterval * 1000);
    }
  }

  setFindBest(theData, theIdx) {
    // this.isFindBestMode = true;
    this.findBestTripIdx = theIdx;
    this.findBestData = theData;
  }

  addFindBestTrip() {
    if (this.state.selectedSegment !== null && this.state.selectedSegment.length !== 0) {
      let aIdxs = [];
      for (var i = 0; i < this.findBestData.length; i++) {
        if (this.findBestData[i].Segment === this.state.selectedSegment[0].res_num) {
          aIdxs.push(i);
        }
      } //<a href="" onclick="" >Select</a>
      if (aIdxs !== null && aIdxs.length !== 0 && this.findBestData[aIdxs[0]] !== null && (typeof this.findBestData[aIdxs[0]]) !== "undefined") {
        /* let aPuInfoTable = '<table style="border: 1px solid darkgreen; border-collapse:collapse;">';
        let aDoInfoTable = '<table style="border: 1px solid darkgreen; border-collapse:collapse;">';
        for (var i = 0; i < aIdxs.length; i++) {
          // React.createElement('i', {onClick: (e) => this.AcceptFindBest(e), className:"accept_fb_btn", id:"accept_fb_'+aIdxs[0]+'", style:"font-size:30px;color:green;"  }, ''),
          aPuInfoTable = aPuInfoTable + '<tr><td style="border: 1px solid darkgreen;" ><i onclick="this.AcceptFindBest()" name="accept_fb_btn" id="accept_fb_' + aIdxs[0] + '" class="fa fa-check-circle-o" style="font-size:30px;color:green;"></i></td><td style="border: 1px solid darkgreen;">' + parseFloat(this.findBestData[aIdxs[i]].PuDist).toFixed(2) + ' Miles</br>' + this.findBestData[aIdxs[i]].PuEtd + '</td><td style="border: 1px solid darkgreen;">' + (parseFloat(this.findBestData[aIdxs[i]].PuDist) + parseFloat(this.findBestData[aIdxs[i]].PuDist)).toFixed(2) + ' Miles</br>' + (this.stringToMins(this.findBestData[aIdxs[i]].DoEtd) - this.stringToMins(this.findBestData[aIdxs[i]].PuEtd)) + ' Mins</td></tr>';
          aDoInfoTable = aDoInfoTable + '<tr><td style="border: 1px solid darkgreen;" ><i onclick="this.AcceptFindBest()" name="accept_fb_btn" id="accept_fb_' + aIdxs[0] + '" class="fa fa-check-circle-o" style="font-size:30px;color:green;"></i></td><td style="border: 1px solid darkgreen;">' + parseFloat(this.findBestData[aIdxs[i]].DoDist).toFixed(2) + ' Miles</br>' + this.findBestData[aIdxs[i]].DoEtd + '</td><td style="border: 1px solid darkgreen;">' + (parseFloat(this.findBestData[aIdxs[i]].PuDist) + parseFloat(this.findBestData[aIdxs[i]].PuDist)).toFixed(2) + ' Miles</br>' + (this.stringToMins(this.findBestData[aIdxs[i]].DoEtd) - this.stringToMins(this.findBestData[aIdxs[i]].PuEtd)) + ' Mins</td></tr>';
        }
        aPuInfoTable = aPuInfoTable + '</table>';
        aDoInfoTable = aDoInfoTable + '</table>'; */
        // let aPuInfoTable = '<table style="width:100%"><tr><td>Deviation:</td><td>'+parseFloat(this.findBestData[aIdxs[0]].PuDist).toFixed(2)+' Miles</td></tr><tr><td>ETD:</td><td>'+this.findBestData[aIdxs[0]].PuEtd+'</td></tr><tr><td colspan="2" style="text-align: center;"><i onclick="this.AcceptFindBest()" name="accept_fb_btn" id="accept_fb_' + aIdxs[0] + '" class="fa fa-check-circle-o" style="font-size:30px;color:green;"></i></td></tr></table>';
        let aPuInfoTable = '<table style="width:100%"><tr><td><font size="4">Deviation:</font></td><td><font size="4">' + parseFloat(this.findBestData[aIdxs[0]].PuDist).toFixed(2) + ' Miles</font></td></tr><tr><td><font size="4">ETD:</font></td><td><font size="4">' + this.findBestData[aIdxs[0]].PuEtd + '</font></td></tr><tr><td colspan="2" style="text-align: center;"><img onclick="this.AcceptFindBest()" name="accept_fb_btn" id="accept_fb_' + aIdxs[0] + '" src="ExternalResources/img/OK.png" alt="Trulli" width="40" height="40"></td></tr></table>';
        let aDoInfoTable = '<table style="width:100%"><tr><td><font size="4">Deviation:</font></td><td><font size="4">' + parseFloat(this.findBestData[aIdxs[0]].DoDist).toFixed(2) + ' Miles</font></td></tr><tr><td><font size="4">ETD:</font></td><td><font size="4">' + this.findBestData[aIdxs[0]].DoEtd + '</font></td></tr></table>';
        this.findBestPuPopup = L.popup({ closeButton: true, autoClose: false, className: "find-best-pu-popup" }).setLatLng(new L.LatLng(parseFloat(this.findBestData[aIdxs[0]].Trip_Pu.split(",")[0]), parseFloat(this.findBestData[aIdxs[0]].Trip_Pu.split(",")[1])))
          .setContent(aPuInfoTable)
          .openOn(this.state.map);
        this.findBestDoPopup = L.popup({ closeButton: true, autoClose: false, className: "find-best-do-popup" }).setLatLng(new L.LatLng(parseFloat(this.findBestData[aIdxs[0]].Trip_Do.split(",")[0]), parseFloat(this.findBestData[aIdxs[0]].Trip_Do.split(",")[1])))
          .setContent(aDoInfoTable)
          .openOn(this.state.map);
        this.findBestPuMarker = L.marker(new L.LatLng(parseFloat(this.findBestData[aIdxs[0]].Trip_Pu.split(",")[0]), parseFloat(this.findBestData[aIdxs[0]].Trip_Pu.split(",")[1])), { icon: marker.pu_hollow }).bindPopup(this.findBestPuPopup).addTo(this.state.map);
        this.findBestDoMarker = L.marker(new L.LatLng(parseFloat(this.findBestData[aIdxs[0]].Trip_Do.split(",")[0]), parseFloat(this.findBestData[aIdxs[0]].Trip_Do.split(",")[1])), { icon: marker.do_hollow }).bindPopup(this.findBestDoPopup).addTo(this.state.map);
        this.findBestDoMarker.openPopup();
        this.findBestPuMarker.openPopup();
        // this.state.map.setView([parseFloat(this.findBestData[aIdxs[0]].Trip_Pu.split(",")[0]), parseFloat(this.findBestData[aIdxs[0]].Trip_Pu.split(",")[1])], 17);
        // this.zoomToMarkers([this.findBestPuMarker, this.findBestDoMarker]);
        let aMarkersGroup = L.featureGroup([this.findBestPuMarker, this.findBestDoMarker]);
        this.state.map.fitBounds(aMarkersGroup.getBounds());
        // this.findBestPuPopup._contentNode.children[0].children[0].children[0].children[0].children[0].onclick = (e) => { this.acceptFindBest(e) }
        this.findBestPuPopup._contentNode.children[0].children[0].children[2].children[0].children[0].onclick = (e) => { this.acceptFindBest(e) }
      }
    }
  }

  acceptFindBest(e) {
    console.log(e);
    let aIdx = parseInt(e.target.id.replace("accept_fb_", ""));
    let socket = openSocket(this.props.GSENodeJsUrl);
    let aThisContext = this;
    socket.on('finish', function (data) {
      console.log('Caught Event "finish" after calling cmd, data: ' + data);
      if (data.toLowerCase().indexOf("finished") >= 0) {
        // success
        Modal.success({
          title: data
        });
        aThisContext.handleAcceptFindBestFinish(aIdx);
      } else {
        Modal.warning({
          content: data
        });
      }
    });
    console.log("Sending -a with: " + this.props.userName + "~" + this.props.selectedDate.replace("-20", "-") + "~" + this.state.trips[this.findBestTripIdx].trip_id + "~" + this.state.trips[this.findBestTripIdx].pu_id + "~" + this.state.trips[this.findBestTripIdx].do_id + "~" + this.findBestData[aIdx].Segment + "~" + this.findBestData[aIdx].PU_after + "~" + this.findBestData[aIdx].DO_after)
    socket.emit("-a", this.props.userName, this.props.selectedDate.replace("-20", "-"), this.state.trips[this.findBestTripIdx].trip_id, this.state.trips[this.findBestTripIdx].pu_id, this.state.trips[this.findBestTripIdx].do_id, this.findBestData[aIdx].Segment, this.findBestData[aIdx].PU_after, this.findBestData[aIdx].DO_after);
  }

  handleReorderStopsFinish(aSegmentId) {
    if (this.findBestPuMarker != null && this.state.map.hasLayer(this.findBestPuMarker)) {
      this.state.map.removeLayer(this.findBestPuMarker);
    }
    if (this.findBestPuPopup != null && this.state.map.hasLayer(this.findBestPuPopup)) {
      this.state.map.removeLayer(this.findBestPuPopup);
    }
    if (this.findBestDoMarker != null && this.state.map.hasLayer(this.findBestDoMarker)) {
      this.state.map.removeLayer(this.findBestDoMarker);
    }
    if (this.findBestDoPopup != null && this.state.map.hasLayer(this.findBestDoPopup)) {
      this.state.map.removeLayer(this.findBestDoPopup);
    }
    // this.isFindBestMode = false;
    this.stopSegment();
    this.clearSelectedSetmentFromMap();
    this.setState({
      selectedSegment: [],
      selectedSegmentPolyline: {},
      selectedSegmentPlayPolylines: [],
      playSegmentTimeOut: null,
      playSegmentVehicleMarker: null,
      playSegmentStatus: "stop"
    });
    this.state.selectedSegment = [];
    this.state.selectedSegmentPolyline = {};
    this.state.selectedSegmentPlayPolylines = [];
    this.state.playSegmentTimeOut = null;
    this.state.playSegmentVehicleMarker = null;
    this.state.playSegmentStatus = "stop";
    this.props.reloadSegmentsOnFinishFindBest(aSegmentId);
    this.findBestTripIdx = -1;
    this.findBestData = [];
    this.findBestPuMarker = null;
    this.findBestDoMarker = null;
    this.findBestPuPopup = null;
    this.findBestDoPopup = null;
    // this.props.getSchedulesBrief();
    this.props.clearFindBest();
  }

  handleAcceptFindBestFinish(aIdx) {
    if (this.findBestPuMarker != null && this.state.map.hasLayer(this.findBestPuMarker)) {
      this.state.map.removeLayer(this.findBestPuMarker);
    }
    if (this.findBestPuPopup != null && this.state.map.hasLayer(this.findBestPuPopup)) {
      this.state.map.removeLayer(this.findBestPuPopup);
    }
    if (this.findBestDoMarker != null && this.state.map.hasLayer(this.findBestDoMarker)) {
      this.state.map.removeLayer(this.findBestDoMarker);
    }
    if (this.findBestDoPopup != null && this.state.map.hasLayer(this.findBestDoPopup)) {
      this.state.map.removeLayer(this.findBestDoPopup);
    }
    // this.isFindBestMode = false;
    this.stopSegment();
    this.clearSelectedSetmentFromMap();
    this.setState({
      selectedSegment: [],
      selectedSegmentPolyline: {},
      selectedSegmentPlayPolylines: [],
      playSegmentTimeOut: null,
      playSegmentVehicleMarker: null,
      playSegmentStatus: "stop"
    });
    this.state.selectedSegment = [];
    this.state.selectedSegmentPolyline = {};
    this.state.selectedSegmentPlayPolylines = [];
    this.state.playSegmentTimeOut = null;
    this.state.playSegmentVehicleMarker = null;
    this.state.playSegmentStatus = "stop";
    this.props.reloadSegmentsOnFinishFindBest(this.findBestData[aIdx].Segment);
    this.findBestTripIdx = -1;
    this.findBestData = [];
    this.findBestPuMarker = null;
    this.findBestDoMarker = null;
    this.findBestPuPopup = null;
    this.findBestDoPopup = null;
    // this.props.getSchedulesBrief();
    this.props.clearFindBest();
  }

  stringToMins(theTimeStr) {
    let aIsAm = true;
    if (theTimeStr.indexOf("A") >= 0) {
      aIsAm = true;
    } else if (theTimeStr.indexOf("P") >= 0) {
      aIsAm = false;
    } else {
      return 0;
    }
    let aHr = 0, aMin = 0;
    aHr = parseInt(theTimeStr.substring(0, 2));
    aMin = parseInt(theTimeStr.substring(2, 4));
    if (!aIsAm && aHr != 12) {
      aHr = aHr + 12;
    }
    return aHr * 60 + aMin;
  }

  isEmptyObj(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop))
        return false;
    }
    return JSON.stringify(obj) === JSON.stringify({});
  }

  convertMinutesToAmPm(pMins) {
    let theMins = -1;
    if (pMins !== null && typeof pMins === "string" && pMins.length != 0) {
      theMins = parseInt(pMins);
    } else if (typeof pMins === "number") {
      theMins = pMins;
    }
    if (theMins < 0) {
      return "";
    }
    let aIsAm = true;
    if (theMins >= 12 * 60) {
      aIsAm = false;
    }
    let aHr = 0, aMin = 0;
    let aHrStr = "", aMinStr = "";
    if (aIsAm) {
      if (aIsAm === 0) {
        return "0000A";
      }
      aHr = Math.floor(theMins / 60);
      aMin = theMins % 60;
      if (aHr < 10) {
        aHrStr = "0" + aHr.toString();
      } else {
        aHrStr = aHr.toString();
      }
      if (aMin < 10) {
        aMinStr = "0" + aMin.toString();
      } else {
        aMinStr = aMin.toString();
      }
      return aHrStr + aMinStr + "A";
    } else {
      if (theMins === 12 * 60) {
        return "1200P";
      }
      aHr = Math.floor((theMins - 12 * 60) / 60);
      aMin = (theMins - 12 * 60) % 60;
      if (aHr < 10) {
        if (aHr === 0) {
          aHrStr = "12";
        } else {
          aHrStr = "0" + aHr.toString();
        }
      } else {
        aHrStr = aHr.toString();
      }
      if (aMin < 10) {
        aMinStr = "0" + aMin.toString();
      } else {
        aMinStr = aMin.toString();
      }
      return aHrStr + aMinStr + "P";
    }
  }

  testRandomLatLng(theRadiusInMeters, theCenterLat, theCenterLng) {
    let r = theRadiusInMeters / 111300,
      u = Math.random(),
      v = Math.random(),
      w = r * Math.sqrt(u),
      t = 2 * Math.PI * v,
      x = w * Math.cos(t),
      lat1 = w * Math.sin(t),
      lng1 = x / Math.cos(theCenterLat),
      aNewLat = theCenterLat + lat1,
      aNewLng = theCenterLng + lng1;
    return new L.LatLng(aNewLat.toFixed(6), aNewLng.toFixed(6));
  }

  testRandomLatLngNW() {
    return this.testRandomLatLng(61155.1, 42.523512, -72.623237); // 38 Miles
  }

  testRandomLatLngNE() {
    return this.testRandomLatLng(61155.1, 42.505145, -71.527162); // 38 Miles
  }

  testRandomLatLngSW() {
    return this.testRandomLatLng(61155.1, 42.335368, -72.667282); // 38 Miles
  }

  testRandomLatLngSE() {
    return this.testRandomLatLng(61155.1, 42.228684, -71.694050); // 38 Miles
  }

  testPlotRandomVehicles() {
    for (var i = 0; i < 1000; i++) {

    }
  }

  tempClearAllSegments() {
    if (this.tempShowAllSegmentsCulster == null || typeof this.tempShowAllSegmentsCulster == "undefined" || this.isEmptyObj(this.tempShowAllSegmentsCulster)) {

    } else {
      this.tempShowAllSegmentsCulster.clearLayers();
      if (this.state.map.hasLayer(this.tempShowAllSegmentsCulster)) {
        this.state.map.removeLayer(this.tempShowAllSegmentsCulster);
      }
      this.tempShowAllSegmentsCulster = {};
    }
  }

  tempShowAllSegments(theBtnId, theSchedulesBrief, theSchedules) {
    this.mapHandleRefreshSegments();
    this.clearTripsFromMap();
    this.stopSegment();
    this.clearSelectedSetmentFromMap();
    this.props.clearFindBest();
    this.tempClearAllSegments();

    this.state.schedulesBrief = theSchedulesBrief;
    this.setState({ schedulesBrief: theSchedulesBrief });
    if (theSchedules != null && typeof theSchedules != "undefined" && theSchedules.length != 0) {
      if (this.tempShowAllSegmentsCulster == null || typeof this.tempShowAllSegmentsCulster == "undefined" || this.isEmptyObj(this.tempShowAllSegmentsCulster)) {
        this.tempShowAllSegmentsCulster = L.markerClusterGroup({ zoomToBoundsOnClick: true });
      } else {
        this.tempShowAllSegmentsCulster.clearLayers();
      }
      if (this.tempShowAllSegmentsCulster != null && typeof this.tempShowAllSegmentsCulster != "undefined" && !this.isEmptyObj(this.tempShowAllSegmentsCulster)) {
        if (!this.state.map.hasLayer(this.tempShowAllSegmentsCulster)) {
          this.state.map.addLayer(this.tempShowAllSegmentsCulster);
        }
        let aSchedules = [];
        for (var i = 0; i < theSchedules.length; i++) {
          aSchedules.push({
            res_num: theSchedules[i].res_num,
            travel_date: theSchedules[i].travel_date,
            stop_num: theSchedules[i].stop_num,
            eta: theSchedules[i].eta,
            etd: theSchedules[i].etd,
            triptime: theSchedules[i].triptime,
            lat: theSchedules[i].lat,
            lng: theSchedules[i].lng,
            est_trav_time: theSchedules[i].est_trav_time,
            trip_id: theSchedules[i].trip_id,
            stop_type: theSchedules[i].stop_type,
            total_hrs_traveled: theSchedules[i].total_hrs_traveled,
            total_miles_traveled: theSchedules[i].total_miles_traveled,
            productivity: theSchedules[i].productivity,
            shared_ride_percentage: theSchedules[i].shared_ride_percentage,
            num_of_trips: theSchedules[i].num_of_trips,
            total_deadheading: theSchedules[i].total_deadheading,
            csp: theSchedules[i].csp,
            driver: theSchedules[i].driver,
            vehicle: theSchedules[i].vehicle,
            client_name: theSchedules[i].client_name,
            driver_notes: theSchedules[i].driver_notes,
            address: theSchedules[i].address,
            citystate: theSchedules[i].citystate,
            oper_id: theSchedules[i].oper_id,
            act_perf_time: theSchedules[i].act_perf_time,
            act_arrive_time: theSchedules[i].act_arrive_time,
            driver_wait: theSchedules[i].driver_wait,
            passenger_wait: theSchedules[i].passenger_wait
          });
        }
        for (var i = 0; i < aSchedules.length; i++) {
          if (aSchedules[i].stop_num == 1) {
            let aPopUp = L.popup({ closeButton: true, autoClose: true, className: "temp_show_all_segments_pu_" + aSchedules[i].trip_id + "_" + i.toString() })
              .setLatLng(new L.LatLng(aSchedules[i].lat, aSchedules[i].lng))
              .setContent(aSchedules[i].trip_id);
            aSchedules[i].pu_marker = L.marker(new L.LatLng(aSchedules[i].lat, aSchedules[i].lng), { icon: marker.pu, title: aSchedules[i].trip_id }).bindPopup(aPopUp);
            if (theBtnId.indexOf("start") >= 0) {
              this.tempShowAllSegmentsCulster.addLayer(aSchedules[i].pu_marker);
            }
          } else if (aSchedules[i].stop_num == 999) {
            let aPopUp = L.popup({ closeButton: true, autoClose: true, className: "temp_show_all_segments_do_" + aSchedules[i].trip_id + "_" + i.toString() })
              .setLatLng(new L.LatLng(aSchedules[i].lat, aSchedules[i].lng))
              .setContent(aSchedules[i].trip_id);
            aSchedules[i].do_marker = L.marker(new L.LatLng(aSchedules[i].lat, aSchedules[i].lng), { icon: marker.do, title: aSchedules[i].trip_id }).bindPopup(aPopUp);
            if (theBtnId.indexOf("end") >= 0) {
              this.tempShowAllSegmentsCulster.addLayer(aSchedules[i].do_marker);
            }
          }
        }
        this.zoomToFeature(this.tempShowAllSegmentsCulster);
      }
    }
  }

  render() {
    return (
      /*{<div id="mapUI" data-tap-disable="true">
        <div ref={(node) => this._mapNode = node} id="map" />
    </div>}*/
      <div ref={(node) => this._mapNode = node} id="map" />
    );
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/Componets/Map.js